isWebp();

function getGtagSendToTargets() {
	const targets = [];
	const add = (id) => {
		if (!id) {
			return;
		}
		const normalized = String(id).trim();
		if (!normalized || targets.indexOf(normalized) !== -1) {
			return;
		}
		// GTM containers are not valid gtag destinations.
		if (normalized.indexOf('GTM-') === 0) {
			return;
		}
		targets.push(normalized);
	};

	add(window.google_tag_id);
	add(window.adwords_tag_id);

	// send_to restricts destinations — only set when secondary IDs need explicit routing.
	// GA-only (or GA+GTM via dataLayer): omit send_to so default group + custom_analytics gtags work.
	// When send_to is needed, include primary GA4 so gtag('config') property still receives events.
	if (targets.length > 0) {
		add(window.google_analytics_id);
	}

	return targets;
}

function replaceStartingEmojiWithSpan(str) {
	let strStr = new String(str);
	// Regular expression to match an emoji (symbols)
	const emojiRegex = /^((\p{Emoji_Presentation}|\p{Extended_Pictographic})(\u200D(\p{Emoji_Presentation}|\p{Extended_Pictographic}))*)/u;

	const match = strStr.match(emojiRegex);

	if (match) {
		// Replace the emoji with a span element
		const emoji = match[0];
		strStr = strStr.replace(emoji, `<span>${emoji}</span>`);
	}

	return strStr;
}

// Функция для получения параметра из URL
function getParams(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

function __userPropertiesObject() {
	const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
	const vh = typeof window !== 'undefined' ? window.innerHeight : 0;
	const viewportFormat = (vw > 0 && vw < 768) ? 'mobile' : 'desktop';

	let mergedObject = Object.assign({
		"user.user_id": window.user_id,
		"user_id": window.user_id,
		"after_pay": window.after_pay,
		"user.platform": detectPlatform(),
		"viewport.width": vw,
		"viewport.height": vh,
		"viewport.format": viewportFormat
	}, window.user_properties);

	if (window.user_variables) {
		mergedObject = Object.assign(mergedObject, window.user_variables);
	}

	if (window.project) {
		Object.keys(window.project).forEach(function (key) {
			const value = window.project[key];

			if (typeof value === "object" && value !== null) {
				// If the value is an object, iterate over its keys
				Object.keys(value).forEach(function (subKey) {
					mergedObject[`project.${key}.${subKey}`] = value[subKey];
				});
			} else {
				// Otherwise, assign the value directly
				mergedObject[`project.${key}`] = value;
			}
		});
	}

	if (typeof subscription_data == 'object') {
		Object.keys(subscription_data).forEach(function (key) {
			let value = subscription_data[key];

			if (typeof value === "object" && value !== null) {
				// If the value is an object, iterate over its keys
				Object.keys(value).forEach(function (subKey) {
					mergedObject[`subscription.${key}.${subKey}`] = value[subKey];
				});
			} else {
				// Otherwise, assign the value directly
				mergedObject[`subscription.${key}`] = value;
			}
		});
	}

	if (window.subscriptions?.length) {
		mergedObject["subscriptions.paywall_ids"] = [...new Set(subscriptions.map(sub => sub.paywall_id))].join(",");
		mergedObject["subscriptions.price_ids"] = [...new Set(subscriptions.map(sub => sub.price?.id))].join(",");
		mergedObject["subscriptions.price_external_ids"] = [...new Set(subscriptions.map(sub => sub.price?.external_id))].join(",");
		mergedObject["subscriptions.price_external_codes"] = [...new Set(subscriptions.map(sub => sub.price?.external_code))].join(",");
		mergedObject["subscriptions.paywall_names"] = [...new Set(subscriptions.map(sub => sub.paywall_name))].join(",");
	}

	if (window.user_properties?.subscription_id && !window.selected_subscription) {
		window.selected_subscription = selectedSubscription();
	}

	if (window.selected_subscription) {
		let flattenedSelectedSubscription = flattenObject(window.selected_subscription, 'selected_subscription');
		mergedObject = Object.assign(mergedObject, flattenedSelectedSubscription);
	}

	if (window.locales) {
		mergedObject = Object.assign(mergedObject, flattenObject(window.locales, 'user_location'));
	}

	return mergedObject;
}

function __ (key, data) {
    let result = new String(key || '');

    // Check if the translation exists
    if (window.translations && window.translations[key]) {
        result = window.translations[key];
    }

    // Replace placeholders with provided data
    if (Array.isArray(data) || typeof data === 'object') {
        for (const [replaceKey, value] of Object.entries(data)) {
            result = result.replace(`{${replaceKey}}`, value);
        }
    } else if (data !== null && data !== '') {
        result = result.replace('{}', data);
    }

    let mergedObject = __userPropertiesObject();

	if (mergedObject) {
        result = replacePlaceholders(result, mergedObject);

		result = replacePlaceholders(result, {
			"user_id": window.user_id,
		});

        if (isFunctionString(result)) {
            result = evaluateFunction(result, mergedObject);
        }
    }

	try {
		let ejsContext = mergedObject || {};
		if (data !== null && typeof data === 'object' && !Array.isArray(data)) {
			ejsContext = Object.assign({}, ejsContext, data);
		}
		result = ejs.render(result, ejsContext);
	} catch (e) {
		console.error('Error in template evaluation', e);
		console.error(result, mergedObject, data);
	}

    return result
}

function _eval(result) {
	let mergedObject = Object.assign({}, window.user_variables, window.user_properties);

    result = replacePlaceholders(result, mergedObject);

    if (isFunctionString(result)) {
        return evaluateFunction(result, mergedObject);
    }

    return result;
}

function replacePlaceholders(str, replacements) {
    // First, handle placeholders with default values (syntax: {placeholder||default_value})
    // Only match valid placeholder names (word characters, dots, underscores, hyphens)
    let replacedStr = str.replace(/{([\w\._-]+)\|\|([^}]*)}/g, (match, varName, defaultValue) => {
        // Check if we have a function value
        if (replacements[varName] && isFunctionString(replacements[varName])) {
            return evaluateFunction(replacements[varName], replacements);
        }

        // Check if we have a direct replacement and it's not empty
        if (replacements[varName] !== undefined && replacements[varName] !== null && replacements[varName] !== '') {
            return replacements[varName];
        }

        // Check nested properties
        const parts = varName.split('.');
        if (parts.length >= 2) {
            if (window[parts[0]] && window[parts[0]][parts[1]] !== undefined && window[parts[0]][parts[1]] !== null && window[parts[0]][parts[1]] !== '') {
                return window[parts[0]][parts[1]];
            }
        }

        // Use default value if no replacement found or replacement is empty
        return defaultValue;
    });

    // Then, handle regular placeholders in the format {variable_name}
    const placeholderPattern = /{([\w\._-]+)}/g;

    // Replace each occurrence of the pattern with the corresponding value from the replacements object
    replacedStr = replacedStr.replace(placeholderPattern, (match, varName) => {
        if (replacements[varName] && isFunctionString(replacements[varName])) {
            return evaluateFunction(replacements[varName], replacements);
        }

		if (replacements[varName] !== undefined) {
			return replacements[varName];
		}

        const parts = varName.split('.');

        if (parts.length === 1) {
            return replacements[varName] !== undefined ? replacements[varName] : match;
        } else if (parts.length >= 2) {
			if (window[parts[0]]) {
				return window[parts[0]][parts[1]]
			} else {
				return "";
			}
        }
    });

    return replacedStr;
}

function TemplateManager() {}

TemplateManager.renderTemplate = function (templateId, data, callback) {

	if (templateId == 'screen-content' && templates_version == 2) {
		templateId = 'block-templates';
	}

	let self = TemplateManager;
	self.templates = self.templates || {};

	if (self.templates[templateId]) {
		let html = ejs.render(self.templates[templateId], data);

		callback && callback(html);

		return html;
	} else {
		$.get("/templates/ejs/" + templateId + ".ejs?v=" + (window.app_version || '') , function (templateData) {
			self.templates[templateId] = templateData;

			let html = ejs.render(self.templates[templateId], data);

			callback && callback(html);
		});
	}
}

function CookieManager() {}

CookieManager.setCookie = function(name, value, days) {

	if (window.no_cookie) {
		return;
	}

    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

CookieManager.getCookie = function(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

function getUserTimezone() {
    var offset = new Date().getTimezoneOffset();
    var offsetHours = Math.floor(Math.abs(offset) / 60);
    var offsetMinutes = Math.abs(offset) % 60;
    var timezone = "UTC" + (offset > 0 ? "-" : "+") + String(offsetHours).padStart(2, '0') + ":" + String(offsetMinutes).padStart(2, '0');
    return timezone;
}

/**
 * Detect OS version from user agent
 * Returns format like "iOS 17.1", "Android 13", "Windows 10", "macOS 14.0"
 *
 * Note: Chrome 110+ freezes Android in UA to "Android 10; K". Prefer
 * detectOSVersionAsync() when the real OS version is needed.
 *
 * Safari freezes the "CPU iPhone OS X_Y" token (e.g. 18_7) while Version/A.B.C
 * tracks closer to the real iOS — when Version major is clearly newer, use it
 * so web↔app identify can match (native SDK reports the real OS).
 */
function detectOSVersion() {
    try {
        const ua = navigator.userAgent;
        const formatOSVersion = (match) => `${match[1]}.${match[2]}${match[3] ? '.' + match[3] : ''}`;

        // iOS detection
        if (/iP(hone|od|ad)/.test(ua)) {
            // Prefer explicit app-reported iOS version (e.g. "iOS 26_2" in Instagram UA)
            // before the generic "CPU iPhone OS ..." token.
            const preferredMatch = ua.match(/\biOS (\d+)[_.](\d+)(?:[_.](\d+))?/);
            if (preferredMatch) {
                return `iOS ${formatOSVersion(preferredMatch)}`;
            }

            const fallbackMatch = ua.match(/OS (\d+)[_.](\d+)(?:[_.](\d+))?/);
            const versionMatch = ua.match(/Version\/(\d+)(?:\.(\d+))?(?:\.(\d+))?/);
            if (fallbackMatch && versionMatch) {
                const osMajor = parseInt(fallbackMatch[1], 10);
                const versionMajor = parseInt(versionMatch[1], 10);
                // Frozen Safari UA: OS 18_x but Version/26.x on a real iOS 26 device
                if (!Number.isNaN(osMajor) && !Number.isNaN(versionMajor) && versionMajor > osMajor) {
                    const patch = versionMatch[3] ? '.' + versionMatch[3] : '';
                    return `iOS ${versionMatch[1]}.${versionMatch[2] || '0'}${patch}`;
                }
            }
            if (fallbackMatch) {
                return `iOS ${formatOSVersion(fallbackMatch)}`;
            }
            return 'iOS';
        }

        // Android detection
        if (/Android/.test(ua)) {
            const match = ua.match(/Android (\d+(?:\.\d+)?)/);
            if (match) {
                return `Android ${match[1]}`;
            }
            return 'Android';
        }

        // Windows detection
        if (/Windows/.test(ua)) {
            if (/Windows NT 10\.0/.test(ua)) return 'Windows 10';
            if (/Windows NT 6\.3/.test(ua)) return 'Windows 8.1';
            if (/Windows NT 6\.2/.test(ua)) return 'Windows 8';
            if (/Windows NT 6\.1/.test(ua)) return 'Windows 7';
            return 'Windows';
        }

        // macOS detection
        if (/Macintosh/.test(ua)) {
            const match = ua.match(/Mac OS X (\d+)[_.](\d+)(?:[_.](\d+))?/);
            if (match) {
                return `macOS ${match[1]}.${match[2]}${match[3] ? '.' + match[3] : ''}`;
            }
            return 'macOS';
        }

        // Linux detection
        if (/Linux/.test(ua)) {
            return 'Linux';
        }

        return 'Unknown';
    } catch (e) {
        return 'Unknown';
    }
}

/**
 * Cached Client Hints fingerprint (one high-entropy request per page load).
 * @type {Promise<{os_version: string|null, device_model: string|null}>|null}
 */
let _clientHintFingerprintPromise = null;

/**
 * Chromium User-Agent Client Hints: real Android version + device model.
 * Chrome 110+ freezes Android in UA to "Android 10; K" and model to "K".
 */
function getClientHintFingerprint() {
    if (_clientHintFingerprintPromise) {
        return _clientHintFingerprintPromise;
    }

    _clientHintFingerprintPromise = (async function () {
        const result = { os_version: null, device_model: null };

        if (!navigator.userAgentData || typeof navigator.userAgentData.getHighEntropyValues !== 'function') {
            return result;
        }

        try {
            const hints = await navigator.userAgentData.getHighEntropyValues(['platformVersion', 'model']);
            const platform = navigator.userAgentData.platform || hints.platform || '';
            const platformVersion = hints.platformVersion;

            if (platform === 'Android' && platformVersion) {
                const major = String(platformVersion).split('.')[0];
                if (major && major !== '0') {
                    result.os_version = `Android ${major}`;
                }
            }

            if (hints.model && String(hints.model).trim() !== '' && String(hints.model).trim() !== 'K') {
                result.device_model = String(hints.model).trim();
            }
        } catch (e) {
            // Firefox/Safari/denied hints
        }

        return result;
    })();

    return _clientHintFingerprintPromise;
}

/**
 * Detect OS version via User-Agent Client Hints (Chromium), with UA fallback.
 * Use this for fingerprinting — Chrome freezes Android in UA to "Android 10; K".
 * Returns same formats as detectOSVersion(), e.g. "Android 14".
 */
async function detectOSVersionAsync() {
    try {
        const hints = await getClientHintFingerprint();
        if (hints.os_version) {
            return hints.os_version;
        }
        return detectOSVersion();
    } catch (e) {
        return 'Unknown';
    }
}

/**
 * Detect device model via Client Hints (e.g. "Pixel 7", "SM-S911B").
 * Returns null when unavailable (Safari/Firefox or denied hints).
 */
async function detectDeviceModelAsync() {
    try {
        const hints = await getClientHintFingerprint();
        return hints.device_model || null;
    } catch (e) {
        return null;
    }
}

function createUrlWithParams(baseUrl, params) {
    const url = new URL(baseUrl, window.location.origin);
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
    return url.toString();
}

/**
 * OpenAI Ads pixel helpers (https://developers.openai.com/ads/measurement-pixel).
 * Minor units use w2w.utils.getCurrencyDecimals / window._currencyDecimalsConfig
 * (same catalog as config/currency.php via CurrencyHelper).
 */
var OPENAI_ADS_SKIP_EVENTS = {
	"Page onvisibilitychange hidden": true,
	"Page beforeunload": true,
	"Page onvisibilitychange visible": true,
	"Page pagehide": true,
	"Paywall scroll 1": true,
	"Viewport click": true,
	"Viewport scroll": true,
	"Viewport screen resize": true,
	"Viewport btn next hidden": true,
};

var OPENAI_ADS_MONETARY_EVENTS = {
	Purchase: true,
	Subscribe: true,
	StartTrial: true,
	InitiateCheckout: true,
	AddPaymentInfo: true,
	AddToCart: true,
	"Paywall click price": true,
	"Paywall Prices visible": true,
	CompletePayment: true,
};

function openaiAdsShouldSkip(eventName) {
	if (!eventName) {
		return false;
	}
	var name = String(eventName);
	if (OPENAI_ADS_SKIP_EVENTS[name]) {
		return true;
	}
	return name.indexOf("Stripe ") === 0;
}

function openaiAdsIsMonetaryEvent(eventName) {
	return !!OPENAI_ADS_MONETARY_EVENTS[eventName];
}

function openaiAdsIsIdentityKey(key) {
	return (
		key === "email" ||
		key === "phone" ||
		key === "customer_name" ||
		key === "first_name" ||
		key === "last_name" ||
		key === "user_country_code" ||
		key === "user_city_name" ||
		key === "user_state_code" ||
		key === "user_zip_code"
	);
}

function openaiAdsNormalizeCurrency(currency) {
	if (currency === undefined || currency === null) {
		return "";
	}
	var code = String(currency).trim().toUpperCase();
	if (!/^[A-Z]{3}$/.test(code)) {
		return "";
	}
	return code;
}

function openaiAdsMinorUnits(major, currency) {
	var decimals = 2;
	if (typeof w2w !== "undefined" && w2w.utils && typeof w2w.utils.getCurrencyDecimals === "function") {
		decimals = w2w.utils.getCurrencyDecimals(currency);
	} else {
		var config = (typeof window !== "undefined" && window._currencyDecimalsConfig) || {};
		if (config[currency] !== undefined) {
			decimals = config[currency];
		}
	}
	return Math.round(Number(major) * Math.pow(10, decimals));
}

/**
 * Amount only for monetary events that also have an ISO 4217 currency.
 * Step indexes, scroll offsets, and numeric answers stay off data.amount.
 */
function openaiAdsResolveAmount(eventName, value, currency) {
	if (!openaiAdsIsMonetaryEvent(eventName)) {
		return null;
	}
	var code = openaiAdsNormalizeCurrency(currency);
	if (!code) {
		return null;
	}
	if (value === undefined || value === null || value === "") {
		return null;
	}
	var numeric = Number(value);
	if (!isFinite(numeric)) {
		return null;
	}
	return {
		amount: openaiAdsMinorUnits(numeric, code),
		currency: code,
	};
}

function openaiAdsNormalizeEmail(email) {
	if (!email || typeof email !== "string") {
		return "";
	}
	return email.trim().toLowerCase();
}

function openaiAdsNormalizePhone(phone) {
	if (phone === undefined || phone === null || phone === "") {
		return "";
	}
	var normalized = String(phone).replace(/[\s().-]/g, "");
	if (normalized.charAt(0) === "+") {
		normalized = normalized.slice(1);
	}
	normalized = normalized.replace(/^0+/, "");
	if (!/^\d{8,15}$/.test(normalized)) {
		return "";
	}
	return normalized;
}

function openaiAdsNormalizeExternalId(id) {
	if (id === undefined || id === null) {
		return "";
	}
	var normalized = String(id).trim();
	if (!normalized || normalized === "null" || normalized === "_removed_") {
		return "";
	}
	return normalized;
}

function openaiAdsNormalizeName(name) {
	if (name === undefined || name === null || name === "") {
		return "";
	}
	return String(name)
		.toLowerCase()
		.replace(/[\s\u0021-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]/g, "");
}

function openaiAdsNormalizeCountry(country) {
	if (!country || typeof country !== "string") {
		return "";
	}
	var code = country.trim().toUpperCase();
	if (!/^[A-Z]{2}$/.test(code)) {
		return "";
	}
	return code;
}

function openaiAdsNormalizeGeo(value, maxLen) {
	if (value === undefined || value === null) {
		return "";
	}
	var text = String(value).trim();
	if (!text) {
		return "";
	}
	return text.slice(0, maxLen);
}

function openaiAdsNormalizePostalCode(value) {
	var text = openaiAdsNormalizeGeo(value, 32);
	if (!text || !/^[A-Za-z0-9 -]+$/.test(text)) {
		return "";
	}
	return text;
}

function openaiAdsSplitName(fullName) {
	if (!fullName || typeof fullName !== "string") {
		return { first: "", last: "" };
	}
	var parts = fullName.trim().split(/\s+/).filter(Boolean);
	if (!parts.length) {
		return { first: "", last: "" };
	}
	return {
		first: parts[0],
		last: parts.slice(1).join(" "),
	};
}

function openaiAdsHash(value) {
	return new Promise(function (resolve) {
		if (!value) {
			resolve("");
			return;
		}
		var settled = false;
		var done = function (hash) {
			if (settled) {
				return;
			}
			settled = true;
			resolve(hash || "");
		};
		try {
			if (typeof hashSHA256 !== "function") {
				done("");
				return;
			}
			hashSHA256(value, function (hash) {
				done(hash);
			});
			var timer = setTimeout(function () {
				done("");
			}, 2000);
			if (timer && typeof timer.unref === "function") {
				timer.unref();
			}
		} catch (e) {
			done("");
		}
	});
}

function openaiAdsBuildInitUser(overrides) {
	var sourceProps = typeof window !== "undefined" && window.user_properties ? window.user_properties : {};
	var props = Object.assign({}, sourceProps, overrides || {});

	var externalSource = "";
	if (typeof window !== "undefined") {
		externalSource = window.user_id || (window.AnalyticsManager && window.AnalyticsManager.user_id) || "";
	}
	var externalId = openaiAdsNormalizeExternalId(externalSource);
	var email = openaiAdsNormalizeEmail(props.email);
	var phone = openaiAdsNormalizePhone(props.phone);
	var split = openaiAdsSplitName(props.customer_name || "");
	var firstName = openaiAdsNormalizeName(props.first_name || split.first);
	var lastName = openaiAdsNormalizeName(props.last_name || split.last);
	var country = openaiAdsNormalizeCountry(props.user_country_code);
	var city = openaiAdsNormalizeGeo(props.user_city_name, 128);
	var region = openaiAdsNormalizeGeo(props.user_state_code, 128);
	var postalCode = openaiAdsNormalizePostalCode(props.user_zip_code);

	return Promise.all([
		openaiAdsHash(externalId),
		openaiAdsHash(email),
		openaiAdsHash(phone),
		openaiAdsHash(firstName),
		openaiAdsHash(lastName),
	]).then(function (hashes) {
		var user = {};
		if (hashes[0]) {
			user.external_id_sha256 = hashes[0];
		}
		if (hashes[1]) {
			user.email_sha256 = hashes[1];
		}
		if (hashes[2]) {
			user.phone_number_sha256 = hashes[2];
		}
		if (hashes[3]) {
			user.first_name_sha256 = hashes[3];
		}
		if (hashes[4]) {
			user.last_name_sha256 = hashes[4];
		}
		if (country) {
			user.country = country;
		}
		if (city) {
			user.city = city;
		}
		if (region) {
			user.region = region;
		}
		if (postalCode) {
			user.postal_code = postalCode;
		}
		return Object.keys(user).length ? user : null;
	});
}

function openaiAdsSyncUser(overrides) {
	if (typeof window === "undefined" || typeof window.oaiq !== "function" || !window.openai_ads_pixel_id) {
		return Promise.resolve();
	}
	var pixelId = window.openai_ads_pixel_id;
	var run = function () {
		return openaiAdsBuildInitUser(overrides).then(function (user) {
			if (!user) {
				return;
			}
			window.oaiq("init", {
				pixelId: pixelId,
				user: user,
			});
		});
	};
	var prev = window.__openaiAdsUserReady || Promise.resolve();
	var next = prev.then(run, run);
	window.__openaiAdsUserReady = next.then(
		function () {
			return null;
		},
		function () {
			return null;
		}
	);
	return next;
}

function openaiAdsAfterUserReady(callback) {
	var ready = typeof window !== "undefined" ? window.__openaiAdsUserReady : null;
	if (ready && typeof ready.then === "function") {
		ready.then(callback, callback);
		return;
	}
	callback();
}

function analyticsManager () {
    let userProperties = {};
	let eventListeners = {};
	let propertySetListeners = {};

	this.getUID = function () {
		// Check URL parameter first
		if (getParams("user_id")) {
			let getUid = getParams("user_id");
			// Skip if it's _removed_, null, or empty
			if (getUid && getUid !== '' && getUid !== "null" && getUid !== "_removed_") {
				CookieManager.setCookie("user_id", getUid, 356);
				return getUid;
			}
		}

		// Check window.user_id
		if (window.user_id && window.user_id !== "_removed_") {
			return window.user_id;
		}

        // Check cookie
        if (CookieManager.getCookie("user_id")) {
            let cookieUserId = CookieManager.getCookie("user_id");
            if (cookieUserId !== "_removed_") {
                return cookieUserId;
            }
        }

        // Return null instead of throwing - will be handled by caller
        return null;
    }

    // Safely get user ID with error handling
    try {
        this.user_id = this.getUID();
    } catch (e) {
        this.user_id = null;
    }

	this.project = location.host;
	this.app_version = window.app_version;

	this.initParams = function () {
		this.quiz = window.quiz_id || getParams('quiz_id') || 0;
		this.quiz_id = window.quiz_id || getParams('quiz_id') || 0;
		this.quiz_version = window.quiz_version || getParams('quiz_version') || 0;
		this.experiment_id = window.experiment_id || null; // experiment_id
		this.experiment_name = window.experiment_name || null; // experiment_name
		this.experiment_user_id = window.experiment_user_id || null; // experiment_user_id
		this.experiment_group_name = window.experiment_group_name || null; // it not null only one time when the user added in the group
		this.user_visit_id = window.user_visit_id;
	}
	this.initParams();


	if (window.paywall) {
		this.paywall_id = window.paywall.id;
		this.paywall_version = window.paywall_version;
	} else {
		if (getParams('paywall_id')) {
			this.paywall_id = getParams('paywall_id');
		}
		if (getParams('paywall_version')) {
			this.paywall_version = getParams('paywall_version');
		}
	}

	// send info about experiment_id
    this.initUser = function () {
		let self = this;

		setTimeout(function() {
			if (CookieManager.getCookie('_fbp')) {
				self.setUserProperty('fbp', CookieManager.getCookie('_fbp'));
			}
		}, 2000);

		function syncTtpCookieToUserProperty() {
			if (window.no_cookie) {
				return;
			}

			var ttp = CookieManager.getCookie('_ttp');
			if (!ttp) {
				return;
			}

			if (!window.user_properties || window.user_properties.ttp !== ttp) {
				self.setUserProperty('ttp', ttp);
			}
		}

		if (window.tiktok_server_side_cookie) {
			syncTtpCookieToUserProperty();
			setTimeout(syncTtpCookieToUserProperty, 500);
		} else {
			setTimeout(syncTtpCookieToUserProperty, 2000);
		}

		// Snapchat _scid cookie for CAPI matching
		setTimeout(function() {
			if (CookieManager.getCookie('_scid')) {
				self.setUserProperty('sc_cookie1', CookieManager.getCookie('_scid'));
			}
		}, 2000);

		// Pinterest _epik cookie for CAPI click_id matching (set by Pinterest Tag).
		// Used as the canonical click_id source server-side (PinterestConversion*Job),
		// with pinclid URL param as a fallback when _epik is unavailable.
		setTimeout(function() {
			if (CookieManager.getCookie('_epik')) {
				self.setUserProperty('epik', CookieManager.getCookie('_epik'));
			}
		}, 2000);

		// An error page renders window.locales = {}, so a visitor who lands there first
		// gets frontend_inited without any geo and the early return below would keep
		// user_country_code empty on every later quiz and paywall visit.
		if (window.locales?.country_code && !window.user_properties?.user_country_code) {
			self.setUserProperty('user_country_code', window.locales.country_code);
		}

		if (window.user_properties && window.user_properties.frontend_inited) {
			return;
		}

		let properties = {
			frontend_inited: window.user_visit_id || "1"
		};

		if (window.locales.country_code) {
			properties.user_country_code = window.locales.country_code;
		}

		if (window.locales.zip) {
			properties.user_zip_code = window.locales.zip;
		}

		if (window.locales.city_name) {
			properties.user_city_name = window.locales.city_name;
		}

		if (window.locales.state_name) {
			properties.user_state_name = window.locales.state_name;
		}

		if (window.locales.state_code) {
			properties.user_state_code = window.locales.state_code;
		}

		properties.user_language = window.quiz?.language || window.paywall?.language || locales.language;

		properties.user_platform = detectPlatform();

		// Device fingerprinting data for cross-platform identification.
		// os_version / device_model are async (Client Hints) — wait before setUserProperties
		// so we don't persist frozen Chrome UA values ("Android 10", model "K").
		(async function () {
			try {
				properties.screen_size = screen.width + "x" + screen.height;
				properties.timezone = getUserTimezone();
				properties.os_version = await detectOSVersionAsync();
				const deviceModel = await detectDeviceModelAsync();
				if (deviceModel) {
					properties.device_model = deviceModel;
				}
			} catch (e) {
			}

			self.setUserProperties(properties);
		})();
	};

    if (localStorage.getItem('initial_url') === null) {
        // If the key does not exist, set the value
        localStorage.setItem('initial_url', location.href);
    }

    this.initial_url = localStorage.getItem('initial_url');

    let self = this;

    setTimeout(function () {
        if (getParams('edit_mode') || window.quiz_editor) {
            return;
        }

		self.initUser();

		let properties = {};

		if (window.posthog) {
            try {
                posthog.identify(
                    self.user_id, // Required. Replace 'distinct_id' with your user's unique identifier
                    { initial_url: self.initial_url } // $set_once, optional
                );
            } catch (e) {
                console.log('Error in posthog', e);
            }
        }

		if (window.clarity) {
			window.clarity("identify", self.user_id.replaceAll("-", ""));
		}

		// Sentry.init (filters) runs via window.sentryOnLoad in layouts/analytics.blade.php
		// before the loader — keep only user/context here once SDK is available.
		// Sentry JS v8+ removed configureScope; use getCurrentScope / setUser / setTag.
        if (window.Sentry) {
            try {
				if (typeof Sentry.setUser === 'function') {
					Sentry.setUser({ id: self.user_id });
				} else if (typeof Sentry.getCurrentScope === 'function') {
					Sentry.getCurrentScope().setUser({ id: self.user_id });
				}

				if (typeof Sentry.setTag === 'function') {
					Sentry.setTag('project_host', self.project);
					if (self.quiz_id) {
						Sentry.setTag('quiz_id', self.quiz_id);
					}
					if (self.paywall_id) {
						Sentry.setTag('paywall_id', self.paywall_id);
					}
				} else if (typeof Sentry.getCurrentScope === 'function') {
					var scope = Sentry.getCurrentScope();
					scope.setTag('project_host', self.project);
					if (self.quiz_id) {
						scope.setTag('quiz_id', self.quiz_id);
					}
					if (self.paywall_id) {
						scope.setTag('paywall_id', self.paywall_id);
					}
				}
            } catch (e) {
                console.log('Error in Sentry', e);
            }
        }

		if (!window.amplitude_disable_set_user_id) {
			if (window.__setAmplitudeUserId) {
				try {
					if (window?.amplitude?.getDeviceId) {
						properties.amplitude_device_id = amplitude.getDeviceId();
					}
					window.__setAmplitudeUserId(self.user_id);
				} catch (e) {
					console.log('Error in amplitude', e);
				}
			} else if (window?.amplitude?.setUserId) {
				try {
					if (window?.amplitude?.getDeviceId) {
						properties.amplitude_device_id = amplitude.getDeviceId();
					}
					amplitude.setUserId(self.user_id);
				} catch (e) {
					console.log('Error in amplitude', e);
				}
			}
		}

		if (self.experiment_group_name) {
			properties['exp_' + self.experiment_id] = self.experiment_group_name;
		}
		if (window.user_properties) {
			for (const key in window.user_properties) {
				if (key.startsWith('exp_')) {
					properties[key] = window.user_properties[key];
				}
			}
		}

		if (Object.keys(properties).length) {
			self.setUserProperties(properties);
		}
    }, 1000);

	this.globalEventProperties = {};

	this.addGlobalEventProperty = function (property, value) {
		this.globalEventProperties[property] = value;
	}

    this.logEvent = function (event, event_properties, options) {
		const logOptions = options || {};
		if (eventListeners[event]) {
			eventListeners[event].forEach(callback => {
				try {
					callback(event_properties);
				} catch (e) {
					console.error("Error in event listener for", event, e);
				}
			});
		}

		// Fire wildcard "*" listeners for all events
		if (eventListeners["*"]) {
			eventListeners["*"].forEach(callback => {
				try {
					callback(event_properties, event);
				} catch (e) {
					console.error("Error in wildcard event listener", e);
				}
			});
		}

		if (logOptions.localOnly) {
			console.log("Event handled locally", event, event_properties);
			return;
		}

		if (getParams('edit_mode')) {
            console.log("Event NOT logged in Edit mode", event, event_properties);

            return;
        }

		let addtionalEventProperties = {
			app_version: this.app_version,
			quiz: this.quiz,
			quiz_id: this.quiz_id,
			quiz_version: this.quiz_version,
			experiment_id: this.experiment_id,
			additional_data: Object.assign({}, this.globalEventProperties, {
				scrollTop: $(window).scrollTop(),
				windowHeight: $(window).height(),
				windowWidth: $(window).width(),
				documentHeight: $(document).height(),
				documentWidth: $(document).width(),
			}),
			paywall_id: this.paywall_id,
			paywall_version: this.paywall_version
		};

		let extendedEventProperties = Object.assign({}, addtionalEventProperties, event_properties);

        console.log("Event logged", event, event_properties);

		if (getParams('webview_ios')) {
			try {
				window.webkit?.messageHandlers?.iosListener?.postMessage(JSON.stringify({
					message: "event",
					data: event_properties,
					event: event
				}));
			} catch (e) {

			}
		}

		if (getParams('webview_flutter')) {
			try {
				window.FlutterChannel?.postMessage(JSON.stringify({
					message: "event",
					data: event_properties,
					event: event
				}));
			} catch (e) {

			}
		}

		if (getParams('webview_android')) {
			try {
				window.Android?.postMessage(JSON.stringify({
					message: "event",
					data: event_properties,
					event: event
				}));
			} catch (e) {

			}
		}

		if (getParams('webview')) {
			try {
				window.parent?.postMessage({
					message: "event",
					data: event_properties,
					event: event
				}, '*');
			} catch (e) {

			}
		}


		try {
			function shouldSendTo(systemKey, eventName, props) {
				try {
					if (!window.analyticsFilters) return { shouldSend: true };
					const fnBody = window.analyticsFilters[systemKey];
					if (!fnBody || typeof fnBody !== 'string' || !fnBody.trim()) return { shouldSend: true };
					// Try to evaluate function body; allow either a raw function definition or code that returns boolean
					let result;
					try {
						// If it's a function declaration like function(event_name, event_properties){...}
						const candidate = eval(`(${fnBody})`);
						if (typeof candidate === 'function') {
							result = candidate(eventName, props);
						} else {
							// Fallback: build a function wrapper
							const f = new Function('event_name', 'event_properties', `${fnBody}`);
							result = f(eventName, props);
						}
					} catch (e) {
						const f = new Function('event_name', 'event_properties', `${fnBody}`);
						result = f(eventName, props);
					}

					// If result is false, skip the event
					if (result === false) {
						return { shouldSend: false };
					}

					// If result is an object with event_name or event_properties, use them as overrides
					if (result && typeof result === 'object' && (result.event_name !== undefined || result.event_properties !== undefined)) {
						return {
							shouldSend: true,
							event_name: result.event_name !== undefined ? result.event_name : eventName,
							event_properties: result.event_properties !== undefined ? result.event_properties : props
						};
					}

					// Otherwise, send event as normal (backward compatibility)
					return { shouldSend: true };
				} catch (e) {
					return { shouldSend: true };
				}
			}
            let analyticsTimeout = 3000;
			const amplitudeResult = shouldSendTo('amplitude', event, extendedEventProperties);
			if (amplitudeResult.shouldSend) {
				let isSkipAmplitude = false;

				if (window.project?.id == 1691 || window.project?.id == 2286) {
					if (getParams('utm_source') === 'applovin' || window.user_properties?.utm_source === 'applovin') {
						isSkipAmplitude = true;
					}
				}

				if (!isSkipAmplitude) {
					const amplitudeEvent = amplitudeResult.event_name !== undefined ? amplitudeResult.event_name : event;
					const amplitudeProps = amplitudeResult.event_properties !== undefined ? amplitudeResult.event_properties : extendedEventProperties;
					if (window.__trackAmplitudeEvent) {
						window.__trackAmplitudeEvent(amplitudeEvent, amplitudeProps);
					} else if (window?.amplitude?.track) {
						amplitude.track(amplitudeEvent, amplitudeProps);
					}
				}
            }

			const posthogResult = shouldSendTo('posthog', event, extendedEventProperties);
			if (window.posthog && posthogResult.shouldSend) {
				const posthogEvent = posthogResult.event_name !== undefined ? posthogResult.event_name : event;
				const posthogProps = posthogResult.event_properties !== undefined ? posthogResult.event_properties : extendedEventProperties;
                posthog.capture(posthogEvent, posthogProps);
            } else {
                // setTimeout(function(){
                //     try {
                //         posthog.capture(event, extendedEventProperties);
                //     } catch (e) {}
                // }, analyticsTimeout);
            }

			// Check if we should skip sending events to TikTok
			const tiktokResult = shouldSendTo('tiktok', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && tiktokResult.shouldSend) {
				const tiktokEvent = tiktokResult.event_name !== undefined ? tiktokResult.event_name : event;
				const tiktokProps = tiktokResult.event_properties !== undefined ? tiktokResult.event_properties : extendedEventProperties;
				function ttq_track(event, extendedEventProperties, userId) {
					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
					let identify = {external_id: userId}

					if (window.user_properties && window.user_properties.email && emailPattern.test(window.user_properties.email)) {
						identify.email = window.user_properties.email;
					}

					ttq.identify(identify)

					// Prepare event_id for deduplication (passed as third parameter to ttq.track)
					let eventId;
					if (extendedEventProperties.eventID) {
						eventId = extendedEventProperties.eventID;
					} else if (extendedEventProperties.event_id) {
						eventId = extendedEventProperties.event_id;
					} else {
						eventId = userId + '_' + event;
					}

					// Prepare TikTok event properties (without event_id)
					let tiktokEventData = {};

					// Add currency and value if available
					if (extendedEventProperties.currency) {
						tiktokEventData.currency = extendedEventProperties.currency;
					}
					if (extendedEventProperties.value) {
						tiktokEventData.value = extendedEventProperties.value;
					}

					// content_id must be passed explicitly on commerce events (VSA / Pixel Helper)
					if (extendedEventProperties.content_id) {
						const contentId = String(extendedEventProperties.content_id);
						tiktokEventData.content_id = contentId;
						tiktokEventData.content_type = 'product';
						tiktokEventData.contents = [{
							content_id: contentId,
							content_type: 'product',
							quantity: 1,
							...(extendedEventProperties.value !== undefined && extendedEventProperties.value !== null && extendedEventProperties.value !== ''
								? { price: extendedEventProperties.value }
								: {}),
						}];
					}

					const finalEventData = Object.assign({}, extendedEventProperties, tiktokEventData);

					// Remove event_id from properties as it should be passed separately
					delete finalEventData.eventID;
					delete finalEventData.event_id;

					// Track event with event_id as third parameter
					ttq.track(event, finalEventData, {event_id: eventId});
				}

				if (window.ttq) {
					ttq_track(tiktokEvent, tiktokProps, self.user_id)
				} else {
					// setTimeout(function(){
					// 	try {
					// 		ttq_track(tiktokEvent, tiktokProps, self.user_id)
					// 	} catch (e) {}
					// }, analyticsTimeout);
				}
			}

			// Check if we should skip sending events to Snapchat
			const snapchatResult = shouldSendTo('snapchat', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && snapchatResult.shouldSend) {
				const snapchatEvent = snapchatResult.event_name !== undefined ? snapchatResult.event_name : event;
				const snapchatProps = snapchatResult.event_properties !== undefined ? snapchatResult.event_properties : extendedEventProperties;
				function snaptr_track(event, extendedEventProperties, userId) {
					// Map our events to Snapchat standard events
					let snapEventsMap = {
						'Purchase': 'PURCHASE',
						'Subscribe': 'SUBSCRIBE',
						'InitiateCheckout': 'START_CHECKOUT',
						'CompleteRegistration': 'SIGN_UP',
						'AddPaymentInfo': 'ADD_BILLING',
						'PageView': 'PAGE_VIEW',
						'Paywall Prices visible': 'VIEW_CONTENT',
						'Paywall click price': 'VIEW_CONTENT',
						'StartTrial': 'START_TRIAL',
						'AddToCart': 'ADD_TO_CART',
						'AddToWishlist': 'ADD_TO_WISHLIST',
						'Search': 'SEARCH'
					};

					let snapEventName = snapEventsMap[event] || null;

					// Only send if we have a mapped event
					if (snapEventName) {
						const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
						let userData = {
							user_id: userId
						};

						if (window.user_properties && window.user_properties.email && emailPattern.test(window.user_properties.email)) {
							userData.user_email = window.user_properties.email;
						}

						// Set user data for enhanced matching
						window.snaptr && snaptr('init', userData);

						// Prepare event data
						let snapEventData = {};

						// Add client deduplication ID if not exists
						if (!extendedEventProperties.client_dedup_id && !extendedEventProperties.eventID) {
							snapEventData.client_dedup_id = userId + '_' + event;
						} else if (extendedEventProperties.eventID) {
							snapEventData.client_dedup_id = extendedEventProperties.eventID;
						} else {
							snapEventData.client_dedup_id = extendedEventProperties.client_dedup_id;
						}

						// Purchase-like: Pixel only fires on first charge — pay_system_id only
						// (matches CAPI first-invoice order_id). Never use internal subscription_id.
						if (['PURCHASE', 'SUBSCRIBE', 'START_TRIAL'].includes(snapEventName)) {
							if (extendedEventProperties.value) {
								snapEventData.price = extendedEventProperties.value;
							}
							if (extendedEventProperties.currency) {
								snapEventData.currency = extendedEventProperties.currency;
							}
							if (extendedEventProperties.pay_system_id) {
								snapEventData.transaction_id = extendedEventProperties.pay_system_id;
							}
						}

						// Track the event
						window.snaptr && snaptr('track', snapEventName, snapEventData);
					}
				}

				if (window.snaptr) {
					snaptr_track(snapchatEvent, snapchatProps, self.user_id)
				} else {
					// setTimeout(function(){
					// 	try {
					// 		snaptr_track(snapchatEvent, snapchatProps, self.user_id)
					// 	} catch (e) {}
					// }, analyticsTimeout);
				}
			}

			// Check if we should skip sending events to Pinterest
			const pinterestResult = shouldSendTo('pinterest', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && pinterestResult.shouldSend) {
				const pinterestEvent = pinterestResult.event_name !== undefined ? pinterestResult.event_name : event;
				const pinterestProps = pinterestResult.event_properties !== undefined ? pinterestResult.event_properties : extendedEventProperties;
				function pintrk_track(event, extendedEventProperties, userId) {
					// Map our events to Pinterest standard events
					let pinterestEventsMap = {
						'Purchase': 'checkout',
						'Subscribe': 'checkout',
						'InitiateCheckout': 'addtocart',
						'CompleteRegistration': 'signup',
						'AddPaymentInfo': 'addtocart',
						'PageView': 'pagevisit',
						'Paywall Prices visible': 'viewcategory',
						'Paywall click price': 'viewcategory',
						'StartTrial': 'checkout',
						'AddToCart': 'addtocart',
						'Search': 'search'
					};

					let pinterestEventName = pinterestEventsMap[event] || null;

					// Only send if we have a mapped event
					if (pinterestEventName) {
						// Prepare event data
						let pinterestEventData = {
							external_id: userId
						};

						// Add event_id for deduplication (check if eventID exists first)
						if (extendedEventProperties.eventID) {
							pinterestEventData.event_id = extendedEventProperties.eventID;
						} else if (!extendedEventProperties.event_id) {
							pinterestEventData.event_id = userId + '_' + event;
						} else {
							pinterestEventData.event_id = extendedEventProperties.event_id;
						}

						// Add email for enhanced matching
						const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
						if (window.user_properties && window.user_properties.email && emailPattern.test(window.user_properties.email)) {
							pinterestEventData.em = window.user_properties.email;
						}

						// Add transaction data for checkout events
						if (['checkout'].includes(pinterestEventName)) {
							if (extendedEventProperties.value) {
								pinterestEventData.value = extendedEventProperties.value;
							}
							if (extendedEventProperties.currency) {
								pinterestEventData.currency = extendedEventProperties.currency;
							}
							if (extendedEventProperties.subscription_id) {
								pinterestEventData.order_id = extendedEventProperties.subscription_id;
							}
						}

						// Track the event
						window.pintrk && pintrk('track', pinterestEventName, pinterestEventData);
					}
				}

				if (window.pintrk) {
					pintrk_track(pinterestEvent, pinterestProps, self.user_id)
				} else {
					// setTimeout(function(){
					// 	try {
					// 		pintrk_track(pinterestEvent, pinterestProps, self.user_id)
					// 	} catch (e) {}
					// }, analyticsTimeout);
				}
			}

			// Check if we should skip sending events to NewsBreak
			const newsbreakResult = shouldSendTo('newsbreak', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && newsbreakResult.shouldSend) {
				const newsbreakEvent = newsbreakResult.event_name !== undefined ? newsbreakResult.event_name : event;
				const newsbreakProps = newsbreakResult.event_properties !== undefined ? newsbreakResult.event_properties : extendedEventProperties;
				function nbpixel_track(event, extendedEventProperties, userId) {
					// Map our events to NewsBreak standard events
					// Based on NewsBreak documentation, they support these standard events
					let newsbreakEventsMap = {
						'PageView': 'page_view',
						'Purchase': 'purchase',
						'Subscribe': 'subscribe',
						'InitiateCheckout': 'initiate_checkout',
						'CompleteRegistration': 'complete_registration',
						'AddPaymentInfo': 'add_payment_info',
						'AddToCart': 'add_to_cart',
						'AddToWishlist': 'add_to_wishlist',
						'Search': 'search',
						'ViewContent': 'view_content',
						'Lead': 'lead',
						'Contact': 'contact',
						'StartTrial': 'start_trial',
						'Paywall Prices visible': 'view_content',
						'Paywall click price': 'view_content'
					};

					let nbpixelEventName = newsbreakEventsMap[event] || null;

					// Only send if we have a mapped event
					if (nbpixelEventName && window.nbpix) {
						// Prepare event data
						let nbpixelEventData = {};

						// Add standard e-commerce parameters
						if (extendedEventProperties.value) {
							nbpixelEventData.nb_value = extendedEventProperties.value;
						}
						if (extendedEventProperties.currency) {
							nbpixelEventData.currency = extendedEventProperties.currency;
						}

						// Add event_id for deduplication
						if (extendedEventProperties.eventID) {
							nbpixelEventData.event_id = extendedEventProperties.eventID;
						} else if (extendedEventProperties.event_id) {
							nbpixelEventData.event_id = extendedEventProperties.event_id;
						} else {
							nbpixelEventData.event_id = userId + '_' + event;
						}

						// Add user ID
						nbpixelEventData.external_id = userId;

						// Add email if available
						const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
						if (window.user_properties && window.user_properties.email && emailPattern.test(window.user_properties.email)) {
							nbpixelEventData.email = window.user_properties.email;
						}

						// Add subscription/purchase specific data
						if (['purchase', 'subscribe'].includes(nbpixelEventName)) {
							if (extendedEventProperties.subscription_id) {
								nbpixelEventData.order_id = extendedEventProperties.subscription_id;
							}
							if (extendedEventProperties.price_id) {
								nbpixelEventData.content_id = extendedEventProperties.price_id;
							}
						}

						// Track the event
						window.nbpix('event', nbpixelEventName, nbpixelEventData);
					}
				}

				if (window.nbpix) {
					nbpixel_track(newsbreakEvent, newsbreakProps, self.user_id)
				}
			}

			// Taboola Pixel tracking
			const taboolaResult = shouldSendTo('taboola', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && taboolaResult.shouldSend && window._tfa && window.taboola_pixel_id) {
				const taboolaEvent = taboolaResult.event_name !== undefined ? taboolaResult.event_name : event;
				const taboolaProps = taboolaResult.event_properties !== undefined ? taboolaResult.event_properties : extendedEventProperties;

				let taboolaEventsMap = {
					'PageView': 'page_view',
					'Purchase': 'MAKE_PURCHASE',
					'Subscribe': 'MAKE_PURCHASE',
					'InitiateCheckout': 'START_CHECKOUT',
					'CompleteRegistration': 'MAKE_PURCHASE',
					'AddPaymentInfo': 'START_CHECKOUT',
					'AddToCart': 'ADD_TO_CART',
					'AddToWishlist': 'ADD_TO_WISH_LIST',
					'Search': 'SEARCH',
					'StartTrial': 'MAKE_PURCHASE',
					'Paywall Prices visible': 'PRODUCT_VIEW',
					'Paywall click price': 'PRODUCT_VIEW'
				};

				let taboolaEventName = taboolaEventsMap[taboolaEvent] || null;

				if (taboolaEventName) {
					let taboolaNotify = taboolaEventName === 'page_view' ? 'event' : 'ecevent';
					let taboolaPush = {
						notify: taboolaNotify,
						name: taboolaEventName,
						id: parseInt(window.taboola_pixel_id)
					};

					if (taboolaProps.value) {
						taboolaPush.revenue = taboolaProps.value;
					}
					if (taboolaProps.currency) {
						taboolaPush.currency = taboolaProps.currency;
					}
					if (taboolaProps.subscription_id) {
						taboolaPush.orderid = taboolaProps.subscription_id;
					}

					window._tfa.push(taboolaPush);
				}
			}

			// Outbrain Pixel tracking
			const outbrainResult = shouldSendTo('outbrain', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && outbrainResult.shouldSend && window.obApi) {
				const outbrainEvent = outbrainResult.event_name !== undefined ? outbrainResult.event_name : event;
				const outbrainProps = outbrainResult.event_properties !== undefined ? outbrainResult.event_properties : extendedEventProperties;

				let outbrainEventsMap = {
					'PageView': 'PAGE_VIEW',
					'Purchase': 'Purchase',
					'Subscribe': 'Purchase',
					'CompleteRegistration': 'Sign Up',
					'InitiateCheckout': 'Checkout',
					'AddPaymentInfo': 'Checkout',
					'AddToCart': 'Add To Cart',
					'StartTrial': 'Purchase',
					'Paywall Prices visible': 'PAGE_VIEW',
					'Paywall click price': 'PAGE_VIEW'
				};

				let outbrainEventName = outbrainEventsMap[outbrainEvent] || null;

				if (outbrainEventName) {
					let outbrainEventData = {};

					if (outbrainProps.value) {
						outbrainEventData.orderValue = outbrainProps.value;
					}
					if (outbrainProps.currency) {
						outbrainEventData.currency = outbrainProps.currency;
					}
					if (outbrainProps.subscription_id) {
						outbrainEventData.orderId = outbrainProps.subscription_id;
					}

					obApi('track', outbrainEventName, outbrainEventData);
				}
			}

			// Bigo Ads Pixel tracking
			// https://bigoads.com/help/detail?currentLan=EN&id=135&moduleId=11
			// https://www.bigoads.com/help/detail?currentLan=EN&id=85&moduleId=11
			const bigoResult = shouldSendTo('bigo', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && bigoResult.shouldSend && window.bge) {
				const bigoEvent = bigoResult.event_name !== undefined ? bigoResult.event_name : event;
				const bigoProps = bigoResult.event_properties !== undefined ? bigoResult.event_properties : extendedEventProperties;

				let bigoEventsMap = {
					'PageView': 'page_view',
					'Purchase': 'ec_purchase',
					'Subscribe': 'ec_purchase',
					'InitiateCheckout': 'ec_order',
					'CompleteRegistration': 'ec_register',
					'AddPaymentInfo': 'ec_order',
					'AddToCart': 'ec_add_cart',
					'ViewContent': 'ec_detail_view',
					'Lead': 'form',
					'Contact': 'form',
					'StartTrial': 'ec_register',
					'Paywall Prices visible': 'ec_detail_view',
					'Paywall click price': 'button'
				};

				let bigoEventName = bigoEventsMap[bigoEvent] || null;

				if (bigoEventName) {
					let bigoEventData = {};

					if (bigoProps.value !== undefined && bigoProps.value !== null && bigoProps.value !== '') {
						bigoEventData.monetary = String(bigoProps.value);
						bigoEventData.value = bigoProps.value;
					}
					if (bigoProps.currency) {
						bigoEventData.currency = bigoProps.currency;
					}
					if (bigoProps.subscription_id) {
						bigoEventData.transaction_id = bigoProps.subscription_id;
					}

					window.bge('event', bigoEventName, bigoEventData);
				}
			}

			// Microsoft Ads (Bing UET) tracking
			// https://learn.microsoft.com/en-us/advertising/guides/universal-event-tracking
			const microsoftAdsResult = shouldSendTo('microsoft_ads', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && microsoftAdsResult.shouldSend && window.uetq) {
				const microsoftAdsEvent = microsoftAdsResult.event_name !== undefined ? microsoftAdsResult.event_name : event;
				const microsoftAdsProps = microsoftAdsResult.event_properties !== undefined ? microsoftAdsResult.event_properties : extendedEventProperties;

				// Custom event action names so advertisers can create matching UET goals
				let microsoftAdsEventsMap = {
					'PageView': 'page_view',
					'Purchase': 'purchase',
					'Subscribe': 'subscribe',
					'InitiateCheckout': 'begin_checkout',
					'CompleteRegistration': 'sign_up',
					'AddPaymentInfo': 'add_payment_info',
					'AddToCart': 'add_to_cart',
					'ViewContent': 'view_item',
					'Lead': 'generate_lead',
					'Contact': 'contact',
					'StartTrial': 'start_trial',
					'Paywall Prices visible': 'view_item',
					'Paywall click price': 'select_item'
				};

				let microsoftAdsEventName = microsoftAdsEventsMap[microsoftAdsEvent] || null;

				if (microsoftAdsEventName) {
					let microsoftAdsEventData = {};

					if (microsoftAdsProps.value !== undefined && microsoftAdsProps.value !== null && microsoftAdsProps.value !== '') {
						microsoftAdsEventData.revenue_value = microsoftAdsProps.value;
						microsoftAdsEventData.event_value = microsoftAdsProps.value;
					}
					if (microsoftAdsProps.currency) {
						microsoftAdsEventData.currency = microsoftAdsProps.currency;
					}

					if (microsoftAdsEventName === 'page_view') {
						window.uetq.push('event', 'page_view', {
							page_path: window.location.pathname || '/'
						});
					} else {
						window.uetq.push('event', microsoftAdsEventName, microsoftAdsEventData);
					}
				}
			}

			// OpenAI Ads Pixel tracking
			// https://developers.openai.com/ads/measurement-pixel
			// https://developers.openai.com/ads/supported-events
			const openaiAdsResult = shouldSendTo('openai_ads', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && openaiAdsResult.shouldSend && window.oaiq) {
				const openaiAdsEvent = openaiAdsResult.event_name !== undefined ? openaiAdsResult.event_name : event;
				const openaiAdsProps = openaiAdsResult.event_properties !== undefined ? openaiAdsResult.event_properties : extendedEventProperties;

				// Viewport / page-hide noise is OpenAI-only. Step and Answer still go out as custom,
				// but without amount (see openaiAdsResolveAmount).
				if (!openaiAdsShouldSkip(openaiAdsEvent)) {
				// Map web2wave events to OpenAI Ads standard events.
				// Each entry contains the OpenAI event name and the matching `type` (data shape).
				let openaiAdsEventsMap = {
					'PageView':                { name: 'page_viewed',             type: 'contents' },
					'Purchase':                { name: 'order_created',           type: 'contents' },
					'Subscribe':               { name: 'subscription_created',    type: 'plan_enrollment' },
					'StartTrial':              { name: 'trial_started',           type: 'plan_enrollment' },
					'CompleteRegistration':    { name: 'registration_completed',  type: 'customer_action' },
					'InitiateCheckout':        { name: 'checkout_started',        type: 'contents' },
					'AddPaymentInfo':          { name: 'checkout_started',        type: 'contents' },
					'AddToCart':               { name: 'items_added',             type: 'contents' },
					'Lead':                    { name: 'lead_created',            type: 'customer_action' },
					'ViewContent':             { name: 'contents_viewed',         type: 'contents' },
					'Paywall Prices visible':  { name: 'contents_viewed',         type: 'contents' },
					'Paywall click price':     { name: 'contents_viewed',         type: 'contents' }
				};

				let openaiAdsEventDef = openaiAdsEventsMap[openaiAdsEvent] || null;

				// Resolve the OpenAI event name + data shape. For mapped events use the
				// table; for everything else fall back to a `custom` event, mirroring the
				// server-side OpenAiAdsCapiService::resolveEventName(). Without this the
				// browser silently dropped unmapped events while the server still sent
				// them, so custom conversion events diverged between browser and server.
				let openaiAdsEventName;
				let openaiAdsEventData;
				// Per OpenAI Pixel docs (https://developers.openai.com/ads/measurement-pixel),
				// `event_id` and `custom_event_name` belong in the 4th argument (eventOptions),
				// NOT in the event props object. Putting them in props breaks dedupe and
				// custom-event attribution even though the values are "present".
				let openaiAdsEventOptions = {};

				if (openaiAdsEventDef) {
					openaiAdsEventName = openaiAdsEventDef.name;
					openaiAdsEventData = { type: openaiAdsEventDef.type };
				} else {
					openaiAdsEventName = 'custom';
					openaiAdsEventData = { type: 'custom' };

					// Same normalization as the server: lowercase, non [a-z0-9_-] -> '_',
					// trim leading/trailing '_'/'-', cap at 64 chars, fallback 'custom_event'.
					let openaiCustomName = String(openaiAdsEvent)
						.toLowerCase()
						.replace(/[^a-z0-9_-]+/g, '_')
						.replace(/^[_-]+|[_-]+$/g, '')
						.slice(0, 64);
					if (openaiCustomName === '') {
						openaiCustomName = 'custom_event';
					}
					openaiAdsEventOptions.custom_event_name = openaiCustomName;
				}

				if (window.oaiq) {
					// Amount only for monetary events that include a 3-letter ISO currency.
					// Minor units via w2w.utils.getCurrencyDecimals (config/currency.php).
					const openaiAdsMoney = openaiAdsResolveAmount(
						openaiAdsEvent,
						openaiAdsProps.value,
						openaiAdsProps.currency
					);
					if (openaiAdsMoney) {
						openaiAdsEventData.amount = openaiAdsMoney.amount;
						openaiAdsEventData.currency = openaiAdsMoney.currency;
					}

					if (openaiAdsEventDef && openaiAdsEventDef.type === 'plan_enrollment' && openaiAdsProps.price_id) {
						openaiAdsEventData.plan_id = String(openaiAdsProps.price_id);
					}

					// Shared event_id (eventOptions) so the server-side Conversions API event
					// (OpenAiAdsConversionJob builds the same id) deduplicates against this
					// browser pixel hit. Without it OpenAI Ads counts the conversion twice.
					if (openaiAdsProps.eventID) {
						openaiAdsEventOptions.event_id = openaiAdsProps.eventID;
					} else if (openaiAdsProps.event_id) {
						openaiAdsEventOptions.event_id = openaiAdsProps.event_id;
					} else {
						openaiAdsEventOptions.event_id = (window.user_id || '') + '_' + openaiAdsEvent;
					}

					openaiAdsAfterUserReady(function () {
						try {
							oaiq('measure', openaiAdsEventName, openaiAdsEventData, openaiAdsEventOptions);
						} catch (e) {
							console.error('Error logging OpenAI Ads event', e);
						}
					});
				}
				}
			}

			// X (Twitter) Pixel tracking
			// https://business.x.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html
			const twitterResult = shouldSendTo('twitter', event, extendedEventProperties);
			if (!event_properties?.is_skip_send_events && twitterResult.shouldSend && window.twq) {
				const twitterEvent = twitterResult.event_name !== undefined ? twitterResult.event_name : event;
				const twitterProps = twitterResult.event_properties !== undefined ? twitterResult.event_properties : extendedEventProperties;
				const twitterEventIds = window.twitterEventIds || {};
				const twitterEventId = twitterEventIds[twitterEvent];

				// PageView is auto-fired by twq('config'); skip duplicate PageView.
				// Other events require an Event ID from Events Manager.
				if (twitterEventId && twitterEvent !== 'PageView') {
					let twitterEventData = {};

					if (twitterProps.value !== undefined && twitterProps.value !== null && twitterProps.value !== '') {
						const numericValue = Number(twitterProps.value);
						if (!isNaN(numericValue)) {
							twitterEventData.value = numericValue;
						}
					}
					if (twitterProps.currency) {
						twitterEventData.currency = String(twitterProps.currency).toUpperCase();
					}

					// Dedup key shared with server CAPI (conversion_id)
					if (twitterProps.eventID) {
						twitterEventData.conversion_id = twitterProps.eventID;
					} else if (twitterProps.event_id) {
						twitterEventData.conversion_id = twitterProps.event_id;
					} else {
						twitterEventData.conversion_id = (window.user_id || '') + '_' + twitterEvent;
					}

					const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
					if (window.user_properties && window.user_properties.email && emailPattern.test(window.user_properties.email)) {
						twitterEventData.email_address = window.user_properties.email;
					}
					if (window.user_properties && window.user_properties.phone) {
						twitterEventData.phone_number = window.user_properties.phone;
					}

					try {
						twq('event', twitterEventId, twitterEventData);
					} catch (e) {
						console.error('Error logging X (Twitter) event', e);
					}
				}
			}

			let gtagEventsMap = {
				'Purchase': 'purchase',
				'Subscribe': 'purchase',
				'InitiateCheckout': 'begin_checkout',
				'CompleteRegistration': 'sign_up',
				'AddPaymentInfo': 'add_payment_info',
				'PageView': 'page_view',
				'Paywall Prices visible': 'view_item',
				'Paywall click price': 'view_item',
				'StartTrial': 'purchase',
			};

			let gtagEventName = gtagEventsMap[event] || event;

			let gtag_event_properties = mergeObjects({}, event_properties);

			if (window.user_properties?.email) {
				gtag_event_properties.email = window.user_properties?.email;
			}
			if (window.user_id) {
				gtag_event_properties.user_id = window.user_id;
			}
			if (!gtag_event_properties.customer_id && window.user_properties?.stripe_customer_id) {
				gtag_event_properties.customer_id = window.user_properties.stripe_customer_id;
			}

			const gtagSendToTargets = getGtagSendToTargets();
			if (gtagSendToTargets.length === 1) {
				gtag_event_properties.send_to = gtagSendToTargets[0];
			} else if (gtagSendToTargets.length > 1) {
				gtag_event_properties.send_to = gtagSendToTargets;
			}

			const googleResult = shouldSendTo('google', event, gtag_event_properties);
			const googleEvent = googleResult.event_name !== undefined ? googleResult.event_name : event;
			const googleProps = googleResult.event_properties !== undefined ? googleResult.event_properties : gtag_event_properties;
			const googleGtagEventName = gtagEventsMap[googleEvent] || googleEvent;

			// Subscribe + Purchase (and StartTrial) can map to the same GA4 event (e.g. purchase).
			// When event_name_subscribe is "Subscribe,Purchase", logEvent fires both — dedupe by transaction.
			let shouldSendGoogleGtag = googleResult.shouldSend;
			if (shouldSendGoogleGtag) {
				const gtagDedupeId = googleProps.transaction_id || googleProps.subscription_id;
				if (gtagDedupeId) {
					window.__gtagDedupeKeys = window.__gtagDedupeKeys || {};
					const gtagDedupeKey = googleGtagEventName + ':' + gtagDedupeId;
					if (window.__gtagDedupeKeys[gtagDedupeKey]) {
						shouldSendGoogleGtag = false;
					} else {
						window.__gtagDedupeKeys[gtagDedupeKey] = true;
					}
				}
			}

			if ((!window.send_gtag_event_as || window.send_gtag_event_as == 'gtag') && shouldSendGoogleGtag) {
				window.gtag && gtag('event', googleGtagEventName, googleProps);
			}

			if ((!window.send_gtag_event_as || (window.send_gtag_event_as == 'dataLayer' || window.send_gtag_event_as == 'datalayer' )) && shouldSendGoogleGtag) {
				let dataLayerObject = {
					event: googleGtagEventName,
					event_params: googleResult.event_properties !== undefined ? googleResult.event_properties : event_properties
				};
				if (googleProps.email) {
					dataLayerObject.email = googleProps.email;
				}
				if (googleProps.user_id) {
					dataLayerObject.user_id = googleProps.user_id;
				}
				if (googleProps.customer_id) {
					dataLayerObject.customer_id = googleProps.customer_id;
				}

				window.dataLayer && window.dataLayer.push(dataLayerObject);
			}

			if (window.project_id == 806 && shouldSendTo('google', event, gtag_event_properties)) {
				window.dataLayer && window.dataLayer.push({
					event: gtagEventName + "_v2",
					value: event_properties.value,
					currency: event_properties.currency,
					tax: 0,
					shipping: 0,
					transaction_id: event_properties.transaction_id || event_properties.subscription_id,
					user_data: {
						email_address: user_properties?.email,
						country: locales?.country_code, // 2-letter country codes in ISO 3166-1 alpha-2.
						city: locales?.city_name,
						state: locales?.state_code,
						postal_code: locales?.zip,
						external_id: window?.user_id,
					}
				});
			}

			try {
				if (!event_properties?.is_skip_send_events) {
					const applovinResult = shouldSendTo('applovin', event, gtag_event_properties);
					if (window.axon && applovinResult.shouldSend) {
						const applovinEvent = applovinResult.event_name !== undefined ? applovinResult.event_name : event;
						const applovinProps = applovinResult.event_properties !== undefined ? applovinResult.event_properties : gtag_event_properties;

						const applovinEventsMap = {
							'Purchase': 'purchase',
							'Subscribe': 'subscribe',
							'StartTrial': 'subscribe',
							'InitiateCheckout': 'begin_checkout',
							'CompleteRegistration': 'sign_up',
							'AddPaymentInfo': 'add_payment_info',
							'PageView': 'page_view',
							'Paywall Prices visible': 'view_item',
							'Paywall click price': 'view_item',
							'AddToCart': 'add_to_cart',
							'Search': 'search',
						};

						const applovinGtagEventName = applovinEventsMap[applovinEvent] || applovinEvent;

						const applovinEcommerceEvents = [
							// Required events
							'subscribe',
							"page_view",
							"view_item",
							"add_to_cart",
							"begin_checkout",
							"purchase",
							"conversion",
							"start_trial",

							// Recommended events
							"view_item_list",
							"remove_from_cart",
							"add_to_wishlist",
							"view_cart",
							"login",
							"sign_up",
							"search",
							"add_payment_info",
						];

						if (applovinEcommerceEvents.indexOf(applovinGtagEventName) > -1) {
							let axonEventProperties = mergeObjects({}, applovinProps);

							if (axonEventProperties.price_id && axonEventProperties.value && axonEventProperties.currency) {
								let axonItem = {
									item_id: axonEventProperties.price_id,
									item_name: 'Subscription',
									quantity: 1,
									price: axonEventProperties.value,
									currency: axonEventProperties.currency,
									item_category_id: 317,
									image_url: '',
									item_variant_id: 0
								};
								axonEventProperties.items = [axonItem];
								axonEventProperties.value = axonItem.price;
								axonEventProperties.currency = axonItem.currency;
								axonEventProperties.transaction_id = axonEventProperties.transaction_id || axonEventProperties.subscription_id;
							} else if (window.getActivePriceInfo) {
								let price = getActivePriceInfo();
								let axonItem = {
									item_id: price.id || axonEventProperties.price_id,
									item_name: price?.plan?.name || 'Subscription',
									quantity: 1,
									price: price.priceCurrent || axonEventProperties.value,
									currency: price.currency || axonEventProperties.currency,
									item_category_id: 317,
									image_url: '',
									item_variant_id: 0
								};
								axonEventProperties.items = [axonItem];
								axonEventProperties.value = axonItem.price;
								axonEventProperties.currency = axonItem.currency;
								axonEventProperties.transaction_id = axonEventProperties.transaction_id || axonEventProperties.subscription_id;
							}

							axon('track', applovinGtagEventName, axonEventProperties);

							if (applovinGtagEventName === 'begin_checkout') {
								axon('track', 'add_to_cart', axonEventProperties);
							}

							if (applovinGtagEventName === 'page_view') {
								axon('track', 'land', axonEventProperties);
							}
						}
					}
				}
			} catch (e) {
				console.error('Error logging axon event', e);
			}

            // Check if we should skip sending events to Facebook
            const facebookResult = shouldSendTo('facebook', event, extendedEventProperties);
            if (!event_properties?.is_skip_send_events && facebookResult.shouldSend) {
				const facebookEvent = facebookResult.event_name !== undefined ? facebookResult.event_name : event;
				const facebookProps = facebookResult.event_properties !== undefined ? facebookResult.event_properties : extendedEventProperties;
                function sendFbqEvent(event, event_properties) {
                    let fbStandardEvents = [
                        'AddPaymentInfo',
                        'AddToCart',
                        'AddToWishlist',
                        'CompleteRegistration',
                        'Contact',
                        'CustomizeProduct',
                        'Donate',
                        'FindLocation',
                        'InitiateCheckout',
                        'Lead',
                        'Purchase',
                        'Schedule',
                        'Search',
                        'StartTrial',
                        'SubmitApplication',
                        'Subscribe',
                        'ViewContent'
                    ];

                    let skipEvents = [
                        'Page onvisibilitychange hidden',
                        'Paywall click price',
                        'Page beforeunload',
                        'Page onvisibilitychange visible',
                        'Page pagehide',
                        'Paywall scroll 1',
                        'Quiz finished',
                        'Paywall click get_my_plan',
                        'Viewport click',
                        'Viewport scroll',
                        'Viewport screen resize',
                        'Viewport btn next hidden'
                    ]

                    let fb_event_properties = mergeObjects({}, event_properties);

                    if (!fb_event_properties.eventID) {
                        fb_event_properties.eventID = AnalyticsManager.user_id + event;
                    }
					let additionalProperties = {
						eventID: fb_event_properties.eventID
					};

					// Add content_ids from user_properties if not already set by event
					if (!fb_event_properties.content_ids && window.user_properties && window.user_properties.content_ids) {
						let contentIds = window.user_properties.content_ids;
						if (typeof contentIds === 'string') {
							try {
								let parsed = JSON.parse(contentIds);
								if (Array.isArray(parsed)) {
									contentIds = parsed;
								} else {
									contentIds = [contentIds];
								}
							} catch (e) {
								if (contentIds.indexOf('||') !== -1) {
									contentIds = contentIds.split('||').map(function(v) { return v.trim(); }).filter(function(v) { return v !== ''; });
								} else if (contentIds.indexOf(',') !== -1) {
									contentIds = contentIds.split(',').map(function(v) { return v.trim(); }).filter(function(v) { return v !== ''; });
								} else {
									contentIds = [contentIds];
								}
							}
						} else if (!Array.isArray(contentIds)) {
							contentIds = [contentIds];
						}
						if (contentIds.length > 0) {
							fb_event_properties.content_ids = contentIds;
						}
					}

					// Add Facebook Click ID and Browser ID (these are not hashed)
					if (window.user_properties?.fbc || CookieManager.getCookie('_fbc')) {
						additionalProperties.fbc = window.user_properties.fbc || CookieManager.getCookie('_fbc');
						fb_event_properties.fbc = window.user_properties.fbc || CookieManager.getCookie('_fbc');
					}
					if (window.user_properties && window.user_properties.fbp) {
						additionalProperties.fbp = window.user_properties.fbp;
						fb_event_properties.fbp = window.user_properties.fbp;
					}

					// Function to collect all hashes and then send the event
                    function collectHashesAndSend() {
                        let hashPromises = [];

                        // Hash external_id (user_id)
                        if (window.meta_pixel_custom_user_id || !window.meta_pixel_disable_set_user_id) {
                            hashPromises.push(new Promise(resolve => {
                                var metaPixelUserId = window.meta_pixel_custom_user_id || AnalyticsManager.user_id;
                                hashSHA256(metaPixelUserId, function(hashedUserId) {
                                    additionalProperties.external_id = hashedUserId;
                                    fb_event_properties.external_id = hashedUserId;
                                    resolve();
                                });
                            }));
                        }

                        // Hash email if available
                        if (window.user_properties && window.user_properties.email) {
                            const email = window.user_properties?.email?.toLowerCase().trim();
                            if (email) {
                                hashPromises.push(new Promise(resolve => {
                                    hashSHA256(email, function(hashedEmail) {
                                        additionalProperties.em = hashedEmail;
                                        resolve();
                                    });
                                }));
                            }
                        }

                        // Hash phone if available
                        if (window.user_properties && window.user_properties.phone) {
                            let phone = window.user_properties.phone;
                            // Remove any non-numeric characters
                            phone = phone.replace(/\D/g, '');
                            // Remove leading zeros
                            phone = phone.replace(/^0+/, '');

                            if (phone) {
                                hashPromises.push(new Promise(resolve => {
                                    hashSHA256(phone, function(hashedPhone) {
                                        additionalProperties.ph = hashedPhone;
                                        resolve();
                                    });
                                }));
                            }
                        }

                        // Wait for all hashes to complete, then send the event
                        Promise.all(hashPromises).then(() => {
                            if (fbStandardEvents.indexOf(event) > -1) {
                                window.fbq && fbq('track', event, fb_event_properties, additionalProperties);
                            } else {
                                if (
                                    skipEvents.indexOf(event) === -1 &&
                                    event.indexOf('Stripe ') === -1
                                ) {
                                    window.fbq && fbq('trackCustom', event, fb_event_properties, additionalProperties);
                                }
                            }
                        }).catch(error => {
                            console.error('Error collecting hashes for Facebook event:', error);
                            // Fallback: send event without enhanced parameters
                            if (fbStandardEvents.indexOf(event) > -1) {
                                window.fbq && fbq('track', event, fb_event_properties, additionalProperties);
                            } else {
                                if (
                                    skipEvents.indexOf(event) === -1 &&
                                    event.indexOf('Stripe ') === -1
                                ) {
                                    window.fbq && fbq('trackCustom', event, fb_event_properties, additionalProperties);
                                }
                            }
                        });
                    }

                    collectHashesAndSend();
                }

                if (window.fbq) {
                    sendFbqEvent(facebookEvent, facebookProps)
                } else {
                    // setTimeout(function(){
                    //     try {
                    //         sendFbqEvent(facebookEvent, facebookProps)
                    //     } catch (e) {}
                    // }, analyticsTimeout);
                }
            }

			const mixpanelResult = shouldSendTo('mixpanel', event, extendedEventProperties);
			if (window.mixpanel && mixpanelResult.shouldSend) {
				const mixpanelEvent = mixpanelResult.event_name !== undefined ? mixpanelResult.event_name : event;
				const mixpanelProps = mixpanelResult.event_properties !== undefined ? mixpanelResult.event_properties : extendedEventProperties;
				mixpanel.track(mixpanelEvent, mixpanelProps);
			} else {
				// setTimeout(function(){
				// 	try {
				// 		mixpanel.track(event, extendedEventProperties);
				// 	} catch (e) {}
				// }, analyticsTimeout);
			}

			if (window.ym && window.ym_id) {
				try {
					ym(window.ym_id, 'reachGoal', event, extendedEventProperties);
				} catch (e) {
					console.error('Error in YM logging', e);
				}
			}
        } catch (e) {
            console.log('Error in logEvent', e);
        }

		const baseDomain = document.querySelector('meta[name="event-url"]')?.getAttribute('content') || '';
		let url = baseDomain+'/api/analytic/event/event_log';
		if(getParams('test_project_id')) {
			url = url + '?test_project_id=' + getParams('test_project_id');
		} else {
			url = url + '?event_project_id=' + window.project.project_id;
		}

		if (window.project?.id == 845) {
			if (
				event.startsWith('Page') ||
				event.startsWith('Answer')
			) {
				return;
			}
		}

		let paywallIdToSend = this.paywall_id;
		let paywallVersionToSend = this.paywall_version;

		if (event_properties?.paywall_id) {
			paywallIdToSend = event_properties.paywall_id;
		}
		if (event_properties?.paywall_version) {
			paywallVersionToSend = event_properties.paywall_version;
		}

		$.post(url, {
            event_name: event,
            event_value: event_properties && event_properties.value ? event_properties.value : null,
            event_properties: event_properties,

            url: location.href,
            initial_url: this.initial_url,
            referrer: document.referrer || null,
            user_agent: navigator.userAgent,
            user_time: new Date().toLocaleTimeString(),
            user_timezone: getUserTimezone(),
            user_locale: navigator.language || navigator.userLanguage,

            user_id: this.user_id,
            app_version: this.app_version,
            quiz: this.quiz, // TODO удалить, когда будет сущность quiz
            quiz_id: this.quiz_id, // TODO переделать, когда будет сущность quiz в БД
            quiz_version: this.quiz_version,
			experiment_id: this.experiment_id,
			experiment_name: this.experiment_name,
			experiment_user_id: this.experiment_user_id,
			experiment_group_name: this.experiment_group_name,
			additional_data: extendedEventProperties.additional_data,
			paywall_id: paywallIdToSend,
			paywall_version: paywallVersionToSend,
			user_visit_id: this.user_visit_id
        }).fail(function(e) {
			console.log( "Error Event Log", e );
		});
    }

    this.setUserProperty = function (key, value, callback) {
		if (getParams('edit_mode')) {
			// allow saving properties in edit mode
			//return;
		}

		if (!key) {
			console.error("Set property: Empty property key");
			return;
		}

		if (typeof key === "object" && key !== null) {
            for (let property in key) {
                if (key.hasOwnProperty(property)) {
                    this.setUserProperty(property, key[property]);
                }
            }

            return;
        }

        if (window.__identifyAmplitudeProperty) {
            window.__identifyAmplitudeProperty(key, value, 'set');
        } else if (window?.amplitude?.identify && window?.amplitude?.Identify) {
            const identifyEvent = new amplitude.Identify();
            identifyEvent.set(key, value);

            amplitude.identify(identifyEvent);
        }

        if (window.posthog) {
            let o = {};
            o[key] = value;
            posthog.setPersonProperties && posthog.setPersonProperties(o);
        }

		if (window.mixpanel && mixpanel.people && mixpanel.people.set) {
			let mixPanelKey = (key == 'email') ? '$email' : key;

			let mixPanelObject = {};
			mixPanelObject[mixPanelKey] = value;

			mixpanel.people.set(mixPanelObject);
		}

		if (key == 'email') {
			// Hash and re-init OpenAI before Lead so that event can match the new email.
			// Other destinations still receive Lead in this same turn.
			openaiAdsSyncUser({ email: value });
			try {
				if (window.project?.project_id !== 'slayyy-inc') {
					this.logEvent('Lead');
				}
			} catch (e) {
				console.error('Failed to send Lead event');
			}

            // if (window.amplitude) {
            //     amplitude.setUserId(value);
            // }
            //
            // if (window.posthog) {
            //     posthog.identify(value);
            // }

			if (value && typeof value == 'string') {
				value = value.toLocaleLowerCase();
			}

			$('a[href*="{email}"]').each(function () {
				const href = $(this).attr('href');
				$(this).attr('href', __(href));
			});

			$('img[src*="{email}"]').each(function () {
				const src = $(this).attr('src');
				$(this).attr('src', __(src));
			});

			$('a[href*="%7Bemail%7D"]').each(function () {
				const href = $(this).attr('href').replace("%7Bemail%7D", "{email}");
				$(this).attr('href', __(href));
			});

			$('img[src*="%7Bemail%7D"]').each(function () {
				const src = $(this).attr('src').replace("%7Bemail%7D", "{email}");
				$(this).attr('src', __(src));
			});

			CookieManager.setCookie("customer_email", value, 356);
		}

		if (key == 'subscription_id') {
			window.selected_subscription = selectedSubscription(value);
		}

		const baseDomain = document.querySelector('meta[name="event-url"]')?.getAttribute('content') || '';
		let url = baseDomain+'/api/analytic/user/property_set';
		if(getParams('test_project_id')) {
			url = url + '?test_project_id=' + getParams('test_project_id');
		} else {
			url = url + '?event_project_id=' + window.project.project_id;
		}

		window.user_properties = window.user_properties || {};
		window.user_properties[key] = value;

		if (key !== 'email' && openaiAdsIsIdentityKey(key)) {
			openaiAdsSyncUser();
		}

		if (key === 'paywall_slug') {
			// Quiz submit uses persisted paywall_slug only after an in-session choice (trial selector).
			// Server-hydrated user_properties alone must not override the quiz-bound paywall.
			window.__w2wPaywallSlugUserSet = true;
		}

		// Fire property set listeners
		if (propertySetListeners[key]) {
			propertySetListeners[key].forEach(callback => {
				try {
					callback(value, key);
				} catch (e) {
					console.error("Error in property set listener for", key, e);
				}
			});
		}

		// Fire wildcard "*" listeners for all property sets
		if (propertySetListeners["*"]) {
			propertySetListeners["*"].forEach(callback => {
				try {
					callback(value, key);
				} catch (e) {
					console.error("Error in wildcard property set listener", e);
				}
			});
		}

		return $.post(url, {
            property: key,
            value: value,
            quiz_id: this.quiz_id,
            quiz_version: this.quiz_version,
            url: location.href,
            user_id: this.user_id
        })
			.done(function(response) {
				console.log("UserProperty set", key, value);

				if (typeof callback === 'function') {
					callback();
				}
			})
			.fail(function(error) {
				if (typeof callback === 'function') {
					callback();
				}
			});
    }

    this.setUserProperties = function (properties, callback) {
		if (getParams('edit_mode')) {
			// allow saving properties in edit mode
			//return;
		}

		if (!properties || typeof properties !== "object" || Array.isArray(properties)) {
			console.error('setUserProperties expects an object with key-value pairs');
			return;
		}

		// Update analytics platforms
		let openaiAdsIdentityUpdated = false;
		for (let key in properties) {
			if (properties.hasOwnProperty(key)) {
				let value = properties[key];

				if (window.__identifyAmplitudeProperty) {
					window.__identifyAmplitudeProperty(key, value, 'set');
				} else if (window?.amplitude?.identify && window?.amplitude?.Identify) {
					const identifyEvent = new amplitude.Identify();
					identifyEvent.set(key, value);
					amplitude.identify(identifyEvent);
				}

				if (window.posthog) {
					let o = {};
					o[key] = value;
					posthog.setPersonProperties && posthog.setPersonProperties(o);
				}

				if (window.mixpanel && mixpanel.people && mixpanel.people.set) {
					let mixPanelKey = (key == 'email') ? '$email' : key;
					let mixPanelObject = {};
					mixPanelObject[mixPanelKey] = value;
					mixpanel.people.set(mixPanelObject);
				}

				if (key == 'email') {
					CookieManager.setCookie("customer_email", value, 356);
				}

				// Update local user_properties
				window.user_properties = window.user_properties || {};
				window.user_properties[key] = value;

				if (key === 'paywall_slug') {
					window.__w2wPaywallSlugUserSet = true;
				}

				if (openaiAdsIsIdentityKey(key)) {
					openaiAdsIdentityUpdated = true;
				}

				// Fire property set listeners
				if (propertySetListeners[key]) {
					propertySetListeners[key].forEach(callback => {
						try {
							callback(value, key);
						} catch (e) {
							console.error("Error in property set listener for", key, e);
						}
					});
				}

				// Fire wildcard "*" listeners for all property sets
				if (propertySetListeners["*"]) {
					propertySetListeners["*"].forEach(callback => {
						try {
							callback(value, key);
						} catch (e) {
							console.error("Error in wildcard property set listener", e);
						}
					});
				}
			}
		}

		if (openaiAdsIdentityUpdated) {
			openaiAdsSyncUser();
		}

		const baseDomain = document.querySelector('meta[name="event-url"]')?.getAttribute('content') || '';
		let url = baseDomain+'/api/analytic/user/properties_set_bulk';

		if(getParams('test_project_id')) {
			url = url + '?test_project_id=' + getParams('test_project_id');
		} else {
			url = url + '?event_project_id=' + window.project.project_id;
		}

		return $.post(url, {
            properties: properties,
            quiz_id: this.quiz_id,
            quiz_version: this.quiz_version,
            url: location.href,
            user_id: this.user_id
        })
			.done(function(response) {
				console.log("UserProperties set", properties);

				if (typeof callback === 'function') {
					callback();
				}
			})
			.fail(function(error) {
				console.log("Error setting UserProperties", error);
				if (typeof callback === 'function') {
					callback();
				}
			});
    }

    this.deleteUserProperty = function (key) {
		if (getParams('edit_mode')) {
			return;
		}

		if (window.__identifyAmplitudeProperty) {
            window.__identifyAmplitudeProperty(key, value, 'set');
        } else if (window?.amplitude?.identify && window?.amplitude?.Identify) {
            const identifyEvent = new amplitude.Identify();
            identifyEvent.set(key, value);

            amplitude.identify(identifyEvent);
        }

        if (window.posthog) {
            let o = {};
            o[key] = '';
            // TODO change to delete
            posthog.setPersonProperties && posthog.setPersonProperties(o);
        }

        $.post('/api/analytic/user/property_delete', {
            property: key,
            user_id: this.user_id,
            url: location.href
        });

    }

    this.appendUserProperty = function (key, value) {
		if (getParams('edit_mode')) {
			return;
		}

		if (window.__identifyAmplitudeProperty) {
            window.__identifyAmplitudeProperty(key, value, 'append');
        } else if (window?.amplitude?.identify && window?.amplitude?.Identify) {
            const identifyEvent = new amplitude.Identify();
            identifyEvent.append(key, value);

            amplitude.identify && amplitude.identify(identifyEvent);
        }

        if (window.posthog) {
            let o = {};
            o[key] = value;
            // TODO change to real append, not set
            posthog.setPersonProperties && posthog.setPersonProperties(o);
        }

        $.post('/api/analytic/user/property_append', {
            property: key,
            value: value,
            url: location.href,
            user_id: this.user_id
        });

    }


    this.truncateUserProperty = function (property, value) {
		if (getParams('edit_mode')) {
			return;
		}

		if (window.amplitude) {
            //const identifyEvent = new amplitude.Identify();
            //identifyEvent.append(property, value);
            //amplitude.identify(identifyEvent);
        }

        $.post('/api/analytic/user/property_truncate', {user_id: this.user_id, property: property, value: value});
    }


	this.on = function (eventName, callback) {
		if (!eventListeners[eventName]) {
			eventListeners[eventName] = [];
		}
		eventListeners[eventName].push(callback);
	};

	this.onSet = function (property, callback) {
		if (!propertySetListeners[property]) {
			propertySetListeners[property] = [];
		}
		propertySetListeners[property].push(callback);
	};

	if (window.quiz_editor) {
		return;
	}

	document.addEventListener("click", function(event) {
		// Check if the clicked element has the data-send-event attribute
		var target = event.target;

		// Traverse up the DOM tree in case the event target is a child of the element with the attribute
		while (target && !target.hasAttribute("data-send-event")) {
			target = target.parentElement;
		}

		// If we found an element with the data-send-event attribute, log the event
		if (target && target.hasAttribute("data-send-event")) {
			var eventName = target.getAttribute("data-send-event");

			if (eventName) {
				// Send the event using AnalyticsManager.logEvent
				AnalyticsManager.logEvent(eventName);
			}
		}
	});

    if (CookieManager && CookieManager.getCookie("customer_email") && window.user_properties && !user_properties.email) {
        this.setUserProperty('email', CookieManager.getCookie("customer_email"));
		CookieManager.setCookie("customer_email", '');
    }
};

let AnalyticsManager = new analyticsManager();

function unitSystemHelper () {
	this.setUnitSystem = function (unit_system_name) {
		if (['kg', 'cm'].includes(unit_system_name)) {
			AnalyticsManager.setUserProperty("user_units_system", 'metric');
			return;
		}

		if (['lbs', 'ft'].includes(unit_system_name)) {
			AnalyticsManager.setUserProperty("user_units_system", 'imperial');
			return;
		}
		console.error('Wrong unit system provided')
	}

	// Height conversion functions
	this.feetInchesToCm = function (feet, inches = 0) {
		const totalInches = feet * 12 + inches;
		return Math.round(totalInches * 2.54); // Round to 2 decimal places
	}

	this.cmToFeetInches = function (cm) {
		const totalInches = cm / 2.54;
		const feet = Math.floor(totalInches / 12);
		const inches = Math.round((totalInches % 12)); // Round to 2 decimal places
		return { feet: feet, inches: inches, text: `${feet}′${inches}″` };
	}

	// Weight conversion functions
	this.lbsToKg = function (lbs) {
		return Math.round(lbs * 0.453592); // Round to 2 decimal places
	}

	this.kgToLbs = function (kg) {
		return Math.round(kg / 0.453592); // Round to 2 decimal places
	}

	// BMI calculation functions
	this.calculateBMI = function (weight, height, weightUnit = 'kg', heightUnit = 'cm') {
		let weightInKg = weight;
		let heightInCm = height;

		// Convert weight to kg if needed
		if (weightUnit === 'lbs') {
			weightInKg = this.lbsToKg(weight);
		}

		// Convert height to cm if needed
		if (heightUnit === 'ft') {
			// Assume height is in decimal feet (e.g., 5.5 feet)
			heightInCm = this.feetInchesToCm(height, 0);
		} else if (heightUnit === 'in') {
			heightInCm = height * 2.54;
		}

		// Convert height from cm to meters
		const heightInM = heightInCm / 100;

		// Calculate BMI
		const bmi = weightInKg / (heightInM * heightInM);
		return Math.round(bmi * 100) / 100; // Round to 2 decimal places
	}

	this.getBMILevel = function (bmi) {
		if (bmi < 18.5) {
			return 'underweight';
		} else if (bmi >= 18.5 && bmi < 25) {
			return 'normal';
		} else if (bmi >= 25 && bmi < 30) {
			return 'overweight';
		} else {
			return 'obese';
		}
	}

	this.getBMILevelWithDescription = function (bmi) {
		const level = this.getBMILevel(bmi);
		const descriptions = {
			'underweight': 'Underweight (BMI < 18.5)',
			'normal': 'Normal weight (BMI 18.5-24.9)',
			'overweight': 'Overweight (BMI 25-29.9)',
			'obese': 'Obese (BMI ≥ 30)'
		};
		return {
			level: level,
			description: descriptions[level],
			bmi: bmi
		};
	}

	// Helper function to calculate BMI with feet and inches input
	this.calculateBMIWithFeetInches = function (weight, feet, inches, weightUnit = 'kg') {
		const heightInCm = this.feetInchesToCm(feet, inches);
		return this.calculateBMI(weight, heightInCm, weightUnit, 'cm');
	}
}

let UnitSystemHelper = new unitSystemHelper();

try {
	if (!window.quiz_editor) {
		openaiAdsSyncUser();
		AnalyticsManager.logEvent('PageView');

		document.addEventListener('freeze', function () {
			AnalyticsManager.logEvent('Page freeze');
		});
		document.addEventListener('resume', function () {
			AnalyticsManager.logEvent('Page resume');
		});
		document.onvisibilitychange = function () {
			if (document.hidden) {
				AnalyticsManager.logEvent('Page closed');
			}
		};
		window.addEventListener("beforeunload", function () {
			AnalyticsManager.logEvent('Page beforeunload');
		});
		// window.addEventListener("unload", function () {
		//     AnalyticsManager.logEvent('Page unload');
		// });
		// window.addEventListener("pagehide", function () {
		// 	AnalyticsManager.logEvent('Page pagehide');
		// });
		// window.addEventListener("pageshow", function () {
		//     AnalyticsManager.logEvent('Page pageshow');
		// });
	}
} catch (e) {

}
setTimeout(function(){
	if (window.quiz_editor) {
		return;
	}

	// Throttle flag for email link click
	let emailLinkThrottled = false;

	$(document.body).on('click', '[data-send-email-link]', function () {
		// Check if throttled
		if (emailLinkThrottled) {
			return false;
		}

		// Set throttle flag
		emailLinkThrottled = true;

		// Reset throttle after 1 second
		setTimeout(function() {
			emailLinkThrottled = false;
		}, 1000);

		if (!user_properties.email) {
			// Usage example
			const userEmail = promptForEmail();
			if (!userEmail) {
				emailLinkThrottled = false; // Reset throttle if no email provided
				return;
			}

			AnalyticsManager.setUserProperty('email', userEmail);

			user_properties.email = userEmail;
		}

		AnalyticsManager.logEvent('Send Email Btn Clicked');

		let requestObj = {
			email_to: user_properties.email
		};

        // Only add user_id if it's valid
        if (AnalyticsManager.user_id && AnalyticsManager.user_id !== "_removed_") {
            requestObj.user_id = AnalyticsManager.user_id;
        }

		try {
			if (['active', 'trialing'].indexOf(subscription_data?.status) > -1) {
				requestObj.subscription_id = subscription_data.id;
			}
		} catch (e) {
			console.error('Error getting subscription for send_auth_link')
		}

		if(getParams('test_project_id')) {
			requestObj.test_project_id = getParams('test_project_id');
		}

		$.post('/send_auth_link', requestObj);

		alert('Download link sent to ' + user_properties.email);

		return false;
	});
}, 500);

if (!window.quiz_editor) {
	fullVHfix();
}

function loadLottie(callback) {
	if (typeof lottie === 'undefined') {
		$.getScript('https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.10.2/lottie.min.js', callback);
	} else {
		callback();
	}
}

function initLottieAnimations() {
	const $lottieDivs = $('.lottie-animation').not('[data-lottie-initialized]');

	if ($lottieDivs.length === 0) return;

	loadLottie(function () {
		$lottieDivs.each(function () {
			const $el = $(this);
			const src = $el.data('lottie-src');
			let options = safeJsonParse($el.attr('data-lottie-options'), {});


			const defaultOptions = {
				container: this,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				path: src
			};

			const finalOptions = mergeObjects(defaultOptions, options);
			let animation = lottie.loadAnimation(finalOptions);

			$el.attr('data-lottie-initialized', 'true');
			$el.data('lottie-object', animation);
		});
	});
}

function setWebviewPaddings() {
	try {
		let webview_params = [
			'webview',
			'webview_ios',
			'webview_android',
			'webview_flutter',
		];

		if (webview_params.some(param => getParams(param))) {
			if (getParams('top_padding')) {
				$('body').animate(
					{'padding-top': Number(getParams('top_padding'))}
				);
			}
			if (getParams('bottom_padding')) {
				$('body').animate(
					{'padding-bottom': Number(getParams('bottom_padding'))}
				);
			}
		}
	} catch (e) {
		console.log('Error in setting padding', e);
	}
}

$(function () {
	setWebviewPaddings();
	setTimeout(setWebviewPaddings, 1000);
	if (typeof InAppBrowserDownload !== 'undefined') {
		InAppBrowserDownload.init();
	}
});
let toastTimeout;

function showToast(message, type = 'success', time = 10) {
	const toast = document.getElementById('toast');
	$(toast).show();

	toast.innerHTML = message.replace(/\n/g, '<br>');
	toast.className = `show ${type}`;

	clearTimeout(toastTimeout);
	toastTimeout = setTimeout(hideToast, time*1000);

	AnalyticsManager.logEvent('Show toast', {value: message});
}

function hideToast() {
	const toast = document.getElementById('toast');
	toast.classList.remove('show', 'success', 'error');
	$(toast).hide();
}

function showFullscreenOverlay(html, time = 3, callback) {
	let overlay = document.getElementById('fullscreen-overlay');
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.id = 'fullscreen-overlay';
		overlay.className = 'fullscreen-overlay';
		document.body.appendChild(overlay);
	}
	overlay.innerHTML = `<div class=\"fullscreen-overlay-content\">${html}</div>`;
	overlay.style.display = 'flex';
	setTimeout(() => {
		overlay.style.display = 'none';
		overlay.innerHTML = '';
		if (typeof callback === 'function') {
			callback();
		} else if (isFunctionString(callback)) {
			__(callback);
		}
	}, time * 1000);
}

function showPopup(config) {
	const defaultConfig = {
		title: '',
		content: '',
		buttons: [],
		popupClass: ''
	};

	config = Object.assign({}, defaultConfig, config);

	let overlay = document.getElementById('popup-overlay');
	if (!overlay) {
		overlay = document.createElement('div');
		overlay.id = 'popup-overlay';
		overlay.className = 'w2w-popup';
		document.body.appendChild(overlay);
	}

	let titleHtml = '';
	if (config.title) {
		titleHtml = `<div class="w2w-popup__header">${config.title}</div>`;
	}

	let buttonsHtml = '';
	if (config.buttons && config.buttons.length > 0) {
		buttonsHtml = '<div class="w2w-popup__buttons">';
		config.buttons.forEach((button, index) => {
			const buttonClass = button.class || 'w2w-popup__btn-primary';
			buttonsHtml += `<button class="w2w-popup__btn ${buttonClass}" data-popup-action="${index}">${button.text}</button>`;
		});
		buttonsHtml += '</div>';
	}

	const popupClass = config.popupClass ? ` ${config.popupClass}` : '';
	const popupHtml = `
		<div class="w2w-popup__modal${popupClass}">
			<div class="w2w-popup__content">
				${titleHtml}
				<div class="w2w-popup__body">
					${config.content}
				</div>
				${buttonsHtml}
			</div>
		</div>
	`;

	overlay.innerHTML = popupHtml;
	overlay.style.display = 'flex';

	overlay.addEventListener('click', function(e) {
		if (e.target.hasAttribute('data-popup-action')) {
			const actionIndex = parseInt(e.target.getAttribute('data-popup-action'));
			const button = config.buttons[actionIndex];

			if (button && button.action) {
				if (Array.isArray(button.action)) {
					button.action.forEach(action => executeAction(action));
				} else {
					executeAction(button.action);
				}
			}
		}
	});

	function executeAction(action) {
		if (typeof action === 'function') {
			action();
		} else if (typeof action === 'string') {
			if (isFunctionString && isFunctionString(action)) {
				__(action);
			} else {
				try {
					eval(action);
				} catch (error) {
					console.error('Error executing action:', error);
				}
			}
		}
	}
}

function hidePopup() {
	const overlay = document.getElementById('popup-overlay');
	if (overlay) {
		overlay.style.display = 'none';
		overlay.innerHTML = '';
	}
}

let w2w = {
	showToast: showToast,
	hideToast: hideToast,
	showPopup: showPopup,
	hidePopup: hidePopup,
	copyToClipboard: function(text, callback) {
		if (callback) {
			navigator.clipboard.writeText(text).then(callback);
		} else {
			navigator.clipboard.writeText(text);
		}
	},
	showFullscreenOverlay: showFullscreenOverlay,

	/**
	 * Evaluates a structured conditions object against user properties.
	 * @param {object} conditions - The structured conditions object.
	 * @param {object} user_properties - The user's properties.
	 * @returns {boolean} - True if the conditions are met.
	 */
	evaluateConditions: function(conditions, user_properties) {
		if (!conditions || !Array.isArray(conditions.rules) || conditions.rules.length === 0) {
			return false;
		}

		const evaluator = (rule) => {
			const userValue = user_properties[rule.property];
			const conditionValue = rule.value;

			switch (rule.operator) {
				case 'exists':
					return userValue !== undefined && userValue !== null && userValue !== '';
				case 'not_exists':
					return userValue === undefined || userValue === null || userValue === '';

				case 'equals':
					return userValue == conditionValue;
				case 'not_equals':
					return userValue != conditionValue;

				case 'greater_than':
					return (userValue !== undefined && userValue !== null) && userValue > conditionValue;
				case 'less_than':
					return (userValue !== undefined && userValue !== null) && userValue < conditionValue;
				case 'greater_than_or_equals':
					return (userValue !== undefined && userValue !== null) && userValue >= conditionValue;
				case 'less_than_or_equals':
					return (userValue !== undefined && userValue !== null) && userValue <= conditionValue;

				case 'contains':
					return (userValue !== undefined && userValue !== null) && String(userValue).includes(conditionValue);
				case 'not_contains':
					return (userValue === undefined || userValue === null) || !String(userValue).includes(conditionValue);

				case 'starts_with':
					return (userValue !== undefined && userValue !== null) && String(userValue).startsWith(conditionValue);
				case 'ends_with':
					return (userValue !== undefined && userValue !== null) && String(userValue).endsWith(conditionValue);

				case 'in':
					return (userValue !== undefined && userValue !== null) && Array.isArray(conditionValue) && conditionValue.includes(userValue);
				case 'not_in':
					return (userValue === undefined || userValue === null) || !Array.isArray(conditionValue) || !conditionValue.includes(userValue);

				default:
					console.warn('Unknown operator:', rule.operator);
					return false;
			}
		};

		if (conditions.type === 'AND') {
			return conditions.rules.every(evaluator);
		}
		if (conditions.type === 'OR') {
			return conditions.rules.some(evaluator);
		}
		return false;
	},

	/**
	 * Deep-clone plain quiz/paywall block data.
	 * Prefer structuredClone (handles cycles, avoids JSON.stringify stack overflows on deep trees).
	 * Fall back to an iterative clone so circular refs and deep nesting do not blow the call stack.
	 * @param {*} value
	 * @returns {*}
	 */
	_deepClone: function(value) {
		if (value === null || typeof value !== 'object') {
			return value;
		}

		if (typeof structuredClone === 'function') {
			try {
				return structuredClone(value);
			} catch (e) {
				// DataCloneError for functions / DOM nodes — fall through.
			}
		}

		const root = Array.isArray(value) ? [] : {};
		const seen = new WeakMap();
		seen.set(value, root);
		const stack = [{ src: value, dst: root }];

		while (stack.length) {
			const { src, dst } = stack.pop();
			const keys = Array.isArray(src) ? src.keys() : Object.keys(src);

			for (const key of keys) {
				const child = src[key];
				if (child === null || typeof child !== 'object') {
					dst[key] = child;
					continue;
				}
				if (seen.has(child)) {
					dst[key] = seen.get(child);
					continue;
				}
				const childCopy = Array.isArray(child) ? [] : {};
				seen.set(child, childCopy);
				dst[key] = childCopy;
				stack.push({ src: child, dst: childCopy });
			}
		}

		return root;
	},

	/**
	 * Sets a value on a nested object using a dot-notation path.
	 * @param {object} obj - The object to modify.
	 * @param {string} path - The dot-notation path (e.g., "steps.0.title").
	 * @param {*} value - The value to set.
	 */
	_setNestedProperty: function(obj, path, value) {
		const keys = path.split('.');
		let current = obj;
		for (let i = 0; i < keys.length - 1; i++) {
			const key = keys[i];
			if (current[key] === undefined || typeof current[key] !== 'object' || current[key] === null) {
				current[key] = /^\d+$/.test(keys[i + 1]) ? [] : {};
			}
			current = current[key];
		}
		current[keys[keys.length - 1]] = value;
	},

	/**
	 * Resolves conditional properties for a given block based on user properties.
	 * Uses __userPropertiesObject() internally (user_id, project.*, subscription.*, etc.).
	 * @param {object} block - The block object from your quiz JSON.
	 * @returns {object} A new block object with resolved properties.
	 */
	resolveConditionalProperties: function(block) {
		const resolvedBlock = this._deepClone(block);

		if (block._property_overrides) {
			for (const propPath in block._property_overrides) {
				const overrideRules = block._property_overrides[propPath];
				for (const overrideRule of overrideRules) {
					if (this.evaluateConditions(overrideRule.conditions, __userPropertiesObject())) {
						this._setNestedProperty(resolvedBlock, propPath, overrideRule.value);
						break;
					}
				}
			}
		}
		delete resolvedBlock._property_overrides;
		return resolvedBlock;
	},

	/**
	 * Resolves conditional properties for a content array (screen or paywall blocks).
	 * Resolves each block and, for containers, resolves direct children only (no container-in-container).
	 * Uses __userPropertiesObject() internally.
	 * @param {Array} contentArray - screen.content or paywall content array.
	 * @returns {Array} New array of resolved blocks.
	 */
	resolveScreenContentConditionals: function(contentArray) {
		if (!contentArray || !Array.isArray(contentArray)) return contentArray;
		return contentArray.map(block => {
			const resolved = this.resolveConditionalProperties(block);
			if (resolved.type === 'container' && resolved.content && Array.isArray(resolved.content)) {
				resolved.content = resolved.content.map(nested =>
					this.resolveConditionalProperties(nested)
				);
			}
			return resolved;
		});
	},

	logEvent: function(event, event_properties, options){
		AnalyticsManager.logEvent(event, event_properties, options);
	},

	setUserProperty: function(key, value, callback){
		AnalyticsManager.setUserProperty(key, value, callback);
	},

	setUserProperties: function(properties, callback){
		AnalyticsManager.setUserProperties(properties, callback);
	},

	set: function(key, value, callback){
		AnalyticsManager.setUserProperty(key, value, callback);
	},

	get: function(key, defaultValue) {
		if (typeof defaultValue === 'undefined') {
			defaultValue = '';
		}

		return window.user_properties[key] || defaultValue;
	},

	moveToNextScreen: function (isSkipInEditMode) {
		if (getParams('edit_mode') && isSkipInEditMode) {
			w2w.showToast('Skipping Move to next screen in Edit mode');
			return;
		}
		screensManager.moveToNextScreen();
	},
	moveToScreen: function (screen_id) {
		screensManager.moveToSection(screen_id);
	},
	moveToPreviousScreen: function () {
		screensManager.moveToPreviousScreen();
	},
	onEvent: function (eventName, callback) {
		AnalyticsManager.on(eventName, callback);
	},
	onSet: function (property, callback) {
		AnalyticsManager.onSet(property, callback);
	},

	units: UnitSystemHelper,

	addGlobalEventProperty: function(property, value) {
		AnalyticsManager.addGlobalEventProperty(property, value);
	},

	/**
	 * Create a subscription via POST /api/subscription.
	 * @param {object} data - Subscription payload. Required: payment_system, pay_system_id, plan_id, amount, currency, customer, status. Use payment_system: 8 for Custom (manual/custom gateways).
	 * @param {function} [successCallback] - Called with (response) on success (201). response.data is the created Subscription.
	 * @param {function} [errorCallback] - Called with (xhr, status, error) on failure (e.g. 422 validation).
	 * @returns {jqXHR} - jQuery promise for chaining .done() / .fail().
	 */
	createSubscription: function(data, successCallback, errorCallback) {
		const payload = Object.assign({}, data);
		if (payload.user_id === undefined || payload.user_id === null || payload.user_id === '') {
			payload.user_id = window.user_id;
		}
		if (payload.user_visit_id === undefined || payload.user_visit_id === null || payload.user_visit_id === '') {
			payload.user_visit_id = window.user_visit_id;
		}
		if (payload.payment_system === undefined || payload.payment_system === null || payload.payment_system === '') {
			payload.payment_system = 8;
		}
		if (payload.customer === undefined || payload.customer === null || payload.customer === '') {
			payload.customer = window.user_id;
		}
		if (payload.user_email === undefined || payload.user_email === null || payload.user_email === '') {
			payload.user_email = window.user_properties?.email;
		}
		if (payload.paywall_id === undefined || payload.paywall_id === null || payload.paywall_id === '') {
			payload.paywall_id = window.AnalyticsManager?.paywall_id;
		}
		if (payload.quiz_id === undefined || payload.quiz_id === null || payload.quiz_id === '') {
			payload.quiz_id = window.AnalyticsManager?.quiz_id;
		}

		//const baseDomain = document.querySelector('meta[name="event-url"]')?.getAttribute('content') || '';
		const baseDomain = '';
		let url = baseDomain + '/api/subscription';
		if (getParams('test_project_id')) {
			url = url + '?test_project_id=' + getParams('test_project_id');
		} else if (window.project?.project_id) {
			url = url + '?event_project_id=' + window.project.project_id;
		}
		const req = $.ajax({
			url: url,
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify(payload),
		});
		if (typeof successCallback === 'function') {
			req.done(successCallback);
		}
		if (typeof errorCallback === 'function') {
			req.fail(errorCallback);
		}
		return req;
	},

	utils: {
		capitalizeFirstLetter: function (str) {
			if (!str) return '';
			return str.charAt(0).toUpperCase() + str.slice(1);
		},

		formatCurrency: function (value, currency = "USD", locale = "en-US") {
			return new Intl.NumberFormat(locale, {
				style: "currency",
				currency,
			}).format(value);
		},

		transliterate: function (str) {
			const map = {
				// ===== Cyrillic: Russian =====
				'А':'A','Б':'B','В':'V','Г':'G','Д':'D','Е':'E','Ё':'Yo','Ж':'Zh','З':'Z',
				'И':'I','Й':'Y','К':'K','Л':'L','М':'M','Н':'N','О':'O','П':'P','Р':'R',
				'С':'S','Т':'T','У':'U','Ф':'F','Х':'Kh','Ц':'Ts','Ч':'Ch','Ш':'Sh',
				'Щ':'Shch','Ъ':'','Ы':'Y','Ь':'','Э':'E','Ю':'Yu','Я':'Ya',
				'а':'a','б':'b','в':'v','г':'g','д':'d','е':'e','ё':'yo','ж':'zh','з':'z',
				'и':'i','й':'y','к':'k','л':'l','м':'m','н':'n','о':'o','п':'p','р':'r',
				'с':'s','т':'t','у':'u','ф':'f','х':'kh','ц':'ts','ч':'ch','ш':'sh',
				'щ':'shch','ъ':'','ы':'y','ь':'','э':'e','ю':'yu','я':'ya',
				// Ukrainian extras
				'Є':'Ye','І':'I','Ї':'Yi','Ґ':'G','є':'ye','і':'i','ї':'yi','ґ':'g',

				// ===== German =====
				'Ä':'Ae','Ö':'Oe','Ü':'Ue','ß':'ss','ä':'ae','ö':'oe','ü':'ue',

				// ===== Spanish / Portuguese / French / Italian / Polish / Turkish / Vietnamese =====
				// Most of these are handled by NFD diacritic stripping below.
				// Special cases that don't decompose cleanly:
				'Ñ':'N','ñ':'n','Ç':'C','ç':'c',
				'Ł':'L','ł':'l',          // Polish
				'İ':'I','ı':'i','Ş':'S','ş':'s','Ğ':'G','ğ':'g', // Turkish
				'Đ':'D','đ':'d',          // Vietnamese / Croatian
				'Ø':'O','ø':'o','Æ':'Ae','æ':'ae','Å':'A','å':'a', // Nordic (bonus)

				// ===== Hebrew =====
				'א':'a','ב':'b','ג':'g','ד':'d','ה':'h','ו':'v','ז':'z','ח':'ch','ט':'t',
				'י':'y','כ':'k','ך':'k','ל':'l','מ':'m','ם':'m','נ':'n','ן':'n','ס':'s',
				'ע':'a','פ':'p','ף':'p','צ':'ts','ץ':'ts','ק':'k','ר':'r','ש':'sh','ת':'t',

				// ===== Arabic =====
				'ا':'a','أ':'a','إ':'i','آ':'a','ب':'b','ت':'t','ث':'th','ج':'j','ح':'h',
				'خ':'kh','د':'d','ذ':'dh','ر':'r','ز':'z','س':'s','ش':'sh','ص':'s','ض':'d',
				'ط':'t','ظ':'z','ع':'a','غ':'gh','ف':'f','ق':'q','ك':'k','ل':'l','م':'m',
				'ن':'n','ه':'h','و':'w','ي':'y','ى':'a','ة':'h','ء':'','ؤ':'w','ئ':'y',

				// ===== Thai =====
				'ก':'k','ข':'kh','ฃ':'kh','ค':'kh','ฅ':'kh','ฆ':'kh','ง':'ng',
				'จ':'ch','ฉ':'ch','ช':'ch','ซ':'s','ฌ':'ch','ญ':'y',
				'ฎ':'d','ฏ':'t','ฐ':'th','ฑ':'th','ฒ':'th','ณ':'n',
				'ด':'d','ต':'t','ถ':'th','ท':'th','ธ':'th','น':'n',
				'บ':'b','ป':'p','ผ':'ph','ฝ':'f','พ':'ph','ฟ':'f','ภ':'ph','ม':'m',
				'ย':'y','ร':'r','ล':'l','ว':'w','ศ':'s','ษ':'s','ส':'s','ห':'h','ฬ':'l',
				'อ':'o','ฮ':'h',
				'ะ':'a','ั':'a','า':'a','ำ':'am','ิ':'i','ี':'i','ึ':'ue','ื':'ue',
				'ุ':'u','ู':'u','เ':'e','แ':'ae','โ':'o','ใ':'ai','ไ':'ai',
				'ๅ':'','็':'','่':'','้':'','๊':'','๋':'','์':'','ํ':'','๎':'',

				// ===== Hindi (Devanagari) =====
				'अ':'a','आ':'aa','इ':'i','ई':'ii','उ':'u','ऊ':'uu','ऋ':'ri','ए':'e',
				'ऐ':'ai','ओ':'o','औ':'au','ऍ':'e','ऑ':'o',
				'क':'k','ख':'kh','ग':'g','घ':'gh','ङ':'ng',
				'च':'ch','छ':'chh','ज':'j','झ':'jh','ञ':'ny',
				'ट':'t','ठ':'th','ड':'d','ढ':'dh','ण':'n',
				'त':'t','थ':'th','द':'d','ध':'dh','न':'n',
				'प':'p','फ':'ph','ब':'b','भ':'bh','म':'m',
				'य':'y','र':'r','ल':'l','व':'v',
				'श':'sh','ष':'sh','स':'s','ह':'h',
				'ा':'a','ि':'i','ी':'i','ु':'u','ू':'u','ृ':'ri','े':'e','ै':'ai',
				'ो':'o','ौ':'au','ं':'n','ः':'h','ँ':'n','्':'','़':'',
				'ऽ':'','ॐ':'om',
			};

			// 1) Replace mapped chars (longest-supported segment)
			let result = '';
			for (const ch of str) {
				result += map[ch] !== undefined ? map[ch] : ch;
			}

			// 2) Strip remaining diacritics (handles French, Spanish, Portuguese,
			//    Italian, Vietnamese tones, Polish accents, etc.)
			result = result.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

			return result;
		},
		getCurrencyDecimals: function (code) {
			const config = window._currencyDecimalsConfig || {};
			const defaultDecimals = 2;
			code = (code || 'usd').toUpperCase();
			return config[code] !== undefined ? config[code] : defaultDecimals;
		},
		// Format a major-unit numeric value using the currency's natural decimal places.
		// JPY/KRW etc. → no decimals (rounded to integer). USD/EUR → 2 decimals. BHD → 3.
		formatByDecimals: function (value, currencyCode) {
			const decimals = w2w.utils.getCurrencyDecimals(currencyCode);
			return Number(value).toFixed(decimals);
		},
	}
}
window.w2w = w2w;

const PAYMENT_REDIRECT_PENDING_KEY = 'w2w_payment_redirect_pending';
let paymentRedirectRetryBound = false;

/**
 * Navigate to the post-payment URL and retry when the tab becomes visible again.
 * Browsers may defer or drop location changes while the tab is in the background.
 */
function redirectAfterPaymentSuccess(url) {
	if (!url) {
		return;
	}

	try {
		sessionStorage.setItem(PAYMENT_REDIRECT_PENDING_KEY, url);
		// remove PAYMENT_REDIRECT_PENDING_KEY on pay-finish page
		// window.addEventListener('pagehide', function clearPendingPaymentRedirect() {
		// 	try {
		// 		sessionStorage.removeItem(PAYMENT_REDIRECT_PENDING_KEY);
		// 	} catch (e) {}
		// }, { once: true });
	} catch (e) {}

	const doRedirect = () => {
		try {
			window.location.replace(url);
		} catch (e) {
			window.location.href = url;
		}
	};

	if (!paymentRedirectRetryBound) {
		paymentRedirectRetryBound = true;

		const retryPendingRedirect = () => {
			if (document.hidden) {
				return;
			}
			try {
				const pendingUrl = sessionStorage.getItem(PAYMENT_REDIRECT_PENDING_KEY);
				if (!pendingUrl) {
					return;
				}
				// Already on the target page (e.g. user navigated back via browser history).
				try {
					const pendingPath = new URL(pendingUrl, window.location.origin).pathname;
					if (pendingPath === window.location.pathname) {
						sessionStorage.removeItem(PAYMENT_REDIRECT_PENDING_KEY);
						return;
					}
				} catch (e) {}
				window.location.replace(pendingUrl);
			} catch (e) {}
		};

		document.addEventListener('visibilitychange', retryPendingRedirect);
		window.addEventListener('pageshow', retryPendingRedirect);
		window.addEventListener('focus', retryPendingRedirect);
	}

	doRedirect();
}
window.redirectAfterPaymentSuccess = redirectAfterPaymentSuccess;

function processAnswersBottomBlocks() {
	const answersBottomBlocks = $('.answers-bottom');

	if (answersBottomBlocks.length === 0) {
		$('.answers-bottom-wrapper').remove();
		return;
	}

	let container;
	let insertPosition;

	// Определяем контекст: квиз или пэйвол
	const currentScreen = $('fieldset.quiz__screen').last();
	const paywallScroll = $('.main__paywall-scroll');

	if (currentScreen.length > 0) {
		// Контекст квиза
		container = currentScreen;
		insertPosition = currentScreen.find('div[style*="height: 80px"]');
	} else if (paywallScroll.length > 0) {
		// Контекст пэйвола
		container = paywallScroll;
		insertPosition = null; // Добавляем в конец
	} else {
		return; // Неизвестный контекст
	}

	let wrapper = $('.answers-bottom-wrapper');
	if (wrapper.length === 0) {
		wrapper = $('<div class="answers-bottom-wrapper"></div>');
		if (insertPosition && insertPosition.length > 0) {
			insertPosition.before(wrapper);
		} else {
			container.append(wrapper);
		}
	}

	answersBottomBlocks.each(function() {
		$(this).appendTo(wrapper);
	});
}